<template>
  <div style="height: 100%">
    <!-- 模式切换：应聘者列表（原界面保持不变）/ 日历图（新增，按面试日期+时间排列当天面试） -->
    <div class="ac-tabs-wrap">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="应聘者列表" name="list"></el-tab-pane>
        <el-tab-pane label="日历图" name="calendar"></el-tab-pane>
      </el-tabs>
    </div>
    <!-- 列表模式查询栏：v-if 彻底销毁——日历模式下不渲染 -->
    <div style="display: flex; width: 100%" v-if="activeTab === 'list'">
      <div style="width: 90%; height: 40px">
        <el-row style="margin: 10px; width: 95%; display: flex; padding-left: 20px">
          <el-input v-model="formDatas.ijaName" style="width: 140px" size="mini " placeholder="应聘者"
            clearable></el-input>
          <el-select v-model="formDatas.ijcId" placeholder="招聘渠道" size="mini" style="width: 140px" clearable>
            <el-option v-for="(item, index) in getIvJobChannelList_data || []" :label="item.ijcName" :value="item.ijcId"
              :key="item.ijcId"></el-option>
          </el-select>
          <el-select v-model="formDatas.iuId" placeholder="面试官" size="mini" style="width: 140px" clearable
            v-if="postid == 2">
            <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName" :value="item.iuId"
              :key="item.iuId" :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
          </el-select>

          <el-select size="mini" v-model="formDatas.ijaFeedbackFirst" clearable @change="partserch" placeholder="初始反馈"
            style="width: 150px">
            <el-option label="通过" value="通过"></el-option>
            <el-option label="未通过" value="未通过"></el-option>
            <el-option label="待定" value="待定"></el-option>
            <el-option label="储备" value="储备"></el-option>
          </el-select>
          <el-date-picker v-model="formDatas.ijaEntryDateAgreeStart" type="date" value-format="yyyy-MM-dd"
            placeholder="待入职开始" size="mini" style="width: 140px" clearable @change="partserch">
          </el-date-picker>
          <el-date-picker v-model="formDatas.ijaEntryDateAgreeEnd" type="date" value-format="yyyy-MM-dd"
            placeholder="待入职结束" size="mini" style="width: 140px" clearable @change="partserch">
          </el-date-picker>
          <el-button type="info" size="mini" icon="el-icon-search" @click="IsSerch = true"
            style="margin-left: 10px">更多</el-button>
          <el-button type="info" size="mini" icon="el-icon-search" @click="partserch"
            style="margin-left: 10px">搜索</el-button>
          <el-button type="primary" size="mini" style="margin-right: 10px" @click="bulkImport = true">批量导入</el-button>
          <el-button type="primary" size="mini" style="margin-right: 10px" @click="Out2">批量导出简历</el-button>
          <el-dropdown size="mini" split-button type="warning" style="margin: 0 10px" @click="Out()" @command="Out">
            导出
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item style="background-color: #e6a23c; color: white" command="1">导出全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-if="postid == 2" type="primary" size="mini" style="margin-right: 10px"
            @click="IuUpdata">修改面试官</el-button>
        </el-row>
      </div>
      <div style="width: 10%; height: 40px">
        <el-row style="
            margin: 10px;
            width: 95%;
            display: flex;
            flex-direction: row-reverse;
          ">
          <el-button type="success" size="mini" style="margin-right: 20px" @click="BoxOpen">新建应聘者</el-button>
          <el-badge :value="AfNums || ''" class="item">
            <el-button type="warning" size="mini" style="margin-right: 10px" @click="ApplyForClick">权限申请</el-button>
          </el-badge>
        </el-row>
      </div>
    </div>
    <div class="tablemain">
      <div class="tablecss" v-show="activeTab === 'list'">
        <div style="width: 100%">
          <ve-table ref="vetable" v-if="tableData" :columns="columns" :table-data="tableData" :max-height="tableHight"
            :border-x="true" :border-y="true" :scrollWidth="10" :cell-style-option="cellStyleOption"
            :checkbox-option="checkboxOption" row-key-field-name="ijaId" :cellSelectionOption="cellSelectionOption"
            style="width: 100%" :editOption="editOption" />
          <div v-show="tableData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div class="table-pagination">
          <ve-pagination :total="totalCount" :page-index="formDatas.currentPage" :page-size="formDatas.pageSize"
            :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]" @on-page-number-change="pageNumberChange"
            @on-page-size-change="pageSizeChange" />
        </div>
      </div>
      <!-- 日历图模式（新增）：面试日历子组件（月/周视图）；上报可视范围触发按范围拉取，详情复用 getDetail -->
      <applicant-calendar v-show="activeTab === 'calendar'" :records="calendarRecords" :loading="calLoading"
        @range-change="loadCalendarData" @detail="getDetail"></applicant-calendar>
      <!-- 修改面试官 -->
      <el-dialog title="修改面试官" :visible.sync="IsIuShow" width="40%" top="8vh">
        <el-select v-model="iuIds" placeholder="请选择面试官" size="mini" style="width: 140px" clearable>
          <el-option v-for="(item, index) in getIvUserList_data || []" :label="item.iuName" :value="item.iuId"
            :key="item.iuId" :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="IuhandleClose">取 消</el-button>
          <el-button type="primary" @click="IuSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 面试记录 -->
      <el-dialog title="面试记录" :visible.sync="IsIvRecord" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="IsIvRecordClose">
        <div>
          <ve-table :columns="columnIv" :table-data="IvRecordData" :max-height="500" :border-x="true" :border-y="true"
            :scrollWidth="10" row-key-field-name="dataIndex" :cell-style-option="cellStyleOption" style="width: 100%" />
          <div v-show="IvRecordData.length == 0" class="empty-data">
            暂无数据
          </div>
        </div>
      </el-dialog>
      <!-- 新增 -->
      <el-dialog :title="edit ? '编辑应聘者' : '新增应聘者'" :visible.sync="dialog" width="70%" top="8vh"
        :close-on-press-escape="false" :close-on-click-modal="false" @close="handleClose">
        <el-form ref="formRef" :model="form" label-position="right" size="mini" label-width="100px" :rules="rules"
          style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="" v-if="!edit">
              <el-radio-group v-model="isTalent">
                <el-radio :label="false">新建应聘者</el-radio>
                <el-radio :label="true">人才库查找</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="应聘者" prop="ijaName">
              <el-input v-if="!isTalent" v-model="form.ijaName" style="width: 50%" placeholder="请输入"></el-input>
              <el-select v-else v-model="form.ijawId" filterable placeholder="请选择" @change="ijawIdChange"
                style="width: 200px">
                <el-option v-for="(item, index) in getIvJobApplicantWareList_data || []" :label="item.ijawName"
                  :value="item.ijawId" :key="item.ijawId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="应聘岗位" prop="ijaPost">
              <el-select v-model="form.ijaPost" filterable placeholder="请选择" style="width: 200px">
                <el-option v-for="(item, index) in getIvJobApplicantPostList_data || []" :label="item.ijapName"
                  :value="item.ijapName" :key="item.ijapId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="base城市" prop="ijaBaseCity">
              <el-input v-model="form.ijaBaseCity" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="邀约日期" prop="ijaDateInvite">
              <el-date-picker v-model="form.ijaDateInvite" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                style="width: 200px">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="招聘渠道" prop="ijcId">
              <el-select v-model="form.ijcId" placeholder="请选择" @change="form.ijaRecommended = ''" style="width: 200px">
                <el-option v-for="(item, index) in getIvJobChannelList_data || []" :label="item.ijcName"
                  :value="item.ijcId" :key="item.ijcId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="内推人" prop="ijaRecommended" v-if="form.ijcId == 4">
              <el-input v-model="form.ijaRecommended" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="ijaPhone">
              <el-input v-model="form.ijaPhone" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="性别" prop="ijaSex">
              <el-radio-group v-model="form.ijaSex">
                <el-radio label="男">男</el-radio>
                <el-radio label="女">女</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="学历" prop="ijaEducationLevel">
              <el-select v-model="education" placeholder="请选择" style="width: 200px">
                <el-option label="全日制" value="全日制" :key="1"> </el-option>
                <el-option label="非全日制" value="非全日制" :key="2">
                </el-option>
              </el-select>
              <el-select v-model="form.ijaEducationLevel" placeholder="请选择" style="width: 200px">
                <el-option label="博士研究生" value="博士研究生" :key="2">
                </el-option>
                <el-option label="硕士研究生" value="硕士研究生" :key="3">
                </el-option>
                <el-option label="本科" value="本科" :key="4"> </el-option>
                <el-option label="专科" value="专科" :key="1"> </el-option>
                <el-option label="其他" value="其他" :key="5"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="面试日期" prop="ijaDateInterview">
              <el-date-picker v-model="form.ijaDateInterview" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                style="width: 200px">
              </el-date-picker>
              <el-time-picker v-model="form.ijaTimeInterview" :format="'HH:mm'" value-format="HH:mm"
                placeholder="选择面试时间" style="width: 200px">
              </el-time-picker>
            </el-form-item>
            <!-- <el-form-item label="面试评价(线上)" prop="ijaFeedbackOnline" v-if="edit">
              <el-input type="textarea" v-model="form.ijaFeedbackOnline" style="width: 50%"
                placeholder="请输入"></el-input>
            </el-form-item> -->
            <el-form-item label="是否线上面试" prop="hasOnline">
              <el-radio-group v-model="form.hasOnline">
                <el-radio :label="1">否</el-radio>
                <el-radio :label="2">是</el-radio>
              </el-radio-group>
            </el-form-item>
            <!-- <el-form-item label="面试时间" prop="ijaTimeInterview">
            
            </el-form-item> -->
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">取 消</el-button>
          <el-button type="primary" @click="SureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 筛选 -->
      <el-dialog title="更多搜索" :visible.sync="IsSerch" width="70%" top="8vh" :close-on-click-modal="false">
        <div style="
            width: 94%;
            height: 90%;
            margin: 1% auto;
            background-color: white;
            overflow-y: scroll;
          ">
          <div style="width: 100%; height: 100%; padding: 5%">
            <el-form ref="formDatas" :model="formDatas" label-position="left" size="mini" label-width="150px"
              @submit.native.prevent>
              <div style="width: 50%; display: inline-block">
                <el-form-item label="应聘岗位">
                  <el-select v-model="formDatas.ijaPost" filterable clearable placeholder="请选择" style="width: 200px">
                    <el-option v-for="(item, index) in getIvJobApplicantPostList_data || []" :label="item.ijapName"
                      :value="item.ijapName" :key="item.ijapId"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="base城市">
                  <el-input v-model="formDatas.ijaBaseCity" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="性别(男,女)">
                  <el-select v-model="formDatas.ijaSex" clearable placeholder="请选择" style="width: 130px">
                    <el-option label="男" value="男" key="1"></el-option>
                    <el-option label="女" value="女" key="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否办理入职手续">
                  <el-select v-model="formDatas.ijaEntryStatus" clearable placeholder="请选择" style="width: 130px">
                    <el-option label="是" value="是" key="1"></el-option>
                    <el-option label="否" value="否" key="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="邀约日期">
                  <el-date-picker v-model="formDatas.ijaDateInviteStart" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择开始日期" style="width: 45%">
                  </el-date-picker>
                  -
                  <el-date-picker v-model="formDatas.ijaDateInviteEnd" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择结束日期" style="width: 45%">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="面试时间">
                  <el-date-picker v-model="formDatas.ijaDateInterviewStart" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择开始日期" style="width: 45%">
                  </el-date-picker>
                  -
                  <el-date-picker v-model="formDatas.ijaDateInterviewEnd" type="date" value-format="yyyy-MM-dd"
                    placeholder="选择结束日期" style="width: 45%">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="学历">
                  <el-input v-model="formDatas.ijaEducationLevel" style="width: 140px" size="mini " placeholder="请输入学历"
                    clearable></el-input>
                </el-form-item>
                <el-form-item label="是否线上面试">
                  <el-select v-model="formDatas.hasOnline" clearable placeholder="请选择" style="width: 130px">
                    <el-option label="否" :value="1" key="1"></el-option>
                    <el-option label="是" :value="2" key="2"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div style="width: 50%; display: inline-block">
                <el-form-item label="手机号码">
                   <el-input v-model="formDatas.ijaPhone" style="width: 140px" size="mini " placeholder="请输入手机号码"
                    clearable></el-input>
                </el-form-item>
                <el-form-item label="是否到面">
                  <el-select v-model="formDatas.ijaFace" clearable placeholder="请选择" style="width: 130px">
                    <el-option label="是" value="是" key="1"></el-option>
                    <el-option label="否" value="否" key="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="是否转正">
                  <el-select v-model="formDatas.ijaRegularWorker" clearable placeholder="请选择" style="width: 130px">
                    <el-option label="是" value="是" key="1"></el-option>
                    <el-option label="否" value="否" key="2"></el-option>
                  </el-select>
                </el-form-item>
                <!-- <el-form-item label="归属">
                                    <el-input v-model="formDatas.auBelong" style="width: 80%;" placeholder="请输入"></el-input>
                                </el-form-item> -->
                <el-form-item label="是否发放offer">
                  <el-select v-model="formDatas.ijaOffer" clearable placeholder="请选择" style="width: 130px">
                    <el-option label="是" value="是" key="1"></el-option>
                    <el-option label="否" value="否" key="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="一周留存">
                  <el-select v-model="formDatas.ijaEntryWeek" clearable placeholder="请选择" style="width: 130px">
                    <el-option label="是" value="是" key="1"></el-option>
                    <el-option label="否" value="否" key="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="面试官">
                  <el-input v-model="formDatas.createusername" placeholder="请输入"></el-input>
                </el-form-item>
              </div>

              <el-form-item>
                <el-button type="primary" @click="partserch(), (IsSerch = false)"
                  style="margin-left: 100px">立即搜索</el-button>
                <el-button @click="closeSizer()" style="margin-left: 200px">取消</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-dialog>
      <!-- 性格测试 -->
      <el-dialog title="性格测试结果" :visible.sync="isText" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="isText = false">
        <div v-if="topicArr.qprStatus == 2 && topicArr.qpId == 1">
          <div v-for="(item, index) in topicArr.ivqPaperRecordCharacterList" :key="index">
            <p style="width: 100%; font-size: 19px; margin: 15px 50px">
              性格颜色:
              <span :style="{ color: item.characterCode }">{{
                item.characterName
              }}</span>
            </p>
            <p style="width: 100%; font-size: 19px; margin: 15px 50px 0">
              {{ item.characterAnalysis }}
            </p>
          </div>
          <p style="width: 100%; font-size: 19px; margin: 15px 50px 0">
            <span>红色 : {{ topicArr.qprItemRed }}</span>
            <span style="margin-left: 10px">蓝色 : {{ topicArr.qprItemBlue }}</span>
            <span style="margin-left: 10px">黄色 : {{ topicArr.qprItemYellow }}</span>
            <span style="margin-left: 10px">绿色 : {{ topicArr.qprItemGreen }}</span>
          </p>
        </div>
        <div v-if="topicArr.qprStatus == 2 && topicArr.qpId == 2" style="padding: 0 50px">
          <el-collapse>
            <el-collapse-item v-for="(item, index) in topicArr.iprResultTwoList || []">
              <template slot="title">
                <p style="width: 100%">
                  <span style="color: red"> {{ item.score }}分 </span>
                  <span style="margin-left: 15px">{{ item.title }}</span>
                </p>
              </template>
              <p>
                {{ item.description }}
              </p>
            </el-collapse-item>
          </el-collapse>
        </div>
        <div class="textclass" style="
            width: 100%;
            height: 350px;
            overflow-y: auto;
            padding: 50px 50px 15px;
            overflow-x: hidden;
          ">
          <div id="" v-for="(item, index) in topicArr.ivqPaperTopicList || []" :key="index">
            <p style="margin: 15px 0; font-size: 16px">
              {{ index + 1 }}.({{ item.qttName }}){{ item.qtName }}
            </p>
            <el-radio-group v-model="checkList[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
              v-for="(topic, n) in item.ivqTopicItemList" :key="n" style="display: block" text-color="red">
              <el-radio :label="topic.qtiId" style="margin: 5px" size="medium" border v-model="item.qptAnswerIds"
                disabled>{{
                  topic.qtiValue }}</el-radio>
            </el-radio-group>
            <el-checkbox-group v-model="checkList[index]" v-if="item.qttId == 2"
              v-for="(topic, n) in item.ivqTopicItemList" :key="n">
              <el-checkbox :label="topic.qtiId" style="margin: 5px">{{
                topic.qtiValue
              }}</el-checkbox>
            </el-checkbox-group>
            <el-input style="width: 100%; margin-left: 0px" v-model="checkList[index][0]" placeholder="请输入答案"
              v-if="item.qttId == 4"></el-input>
          </div>
        </div>
      </el-dialog>
      <!-- 编辑办理入职 -->
      <el-dialog title="编辑办理应聘者入职" :visible.sync="RZdialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="RZhandleClose">
        <el-form ref="formRz" :model="RZform" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="是否办理入职" prop="ijaEntryStatus">
              <el-radio-group v-model="RZform.ijaEntryStatus">
                <el-radio label="">空</el-radio>
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="不来报道原因" prop="ijaEntryRefuseReason">
              <el-input v-model="RZform.ijaEntryRefuseReason" type="textarea" style="width: 50%"
                placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="RZhandleClose">取 消</el-button>
          <el-button type="primary" @click="RZSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑到面信息 -->
      <el-dialog title="编辑到面信息" :visible.sync="Facedialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="FacehandleClose">
        <el-form ref="formFace" :model="Faceform" label-position="top" size="mini" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="是否到面" prop="ijaFace">
              <el-radio-group v-model="Faceform.ijaFace">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="初试反馈" prop="ijaFeedbackFirst">
              <el-radio-group v-model="Faceform.ijaFeedbackFirst">
                <el-radio label="通过">通过</el-radio>
                <el-radio label="未通过">未通过</el-radio>
                <el-radio label="待定">待定</el-radio>
                <el-radio label="储备">储备</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="代面招聘" prop="iuIdInstead">
              <el-select v-model="Faceform.iuIdInstead" placeholder="请选择">
                <el-option v-for="(item, index) in getIvUserList_dataTwo || []" :label="item.iuName" :value="item.iuId"
                  :key="item.iuId" :style="{ color: item.dmDelete == 2 ? 'red' : '' }"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="身份证" prop="ijaIdcard">
              <el-input v-model="Faceform.ijaIdcard" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="面试评价(线下)" prop="ijaFeedbackFollow">
              <el-input v-model="Faceform.ijaFeedbackFollow" type="textarea" style="width: 50%"
                placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="FacehandleClose">取 消</el-button>
          <el-button type="primary" @click="FaceSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑是否转正 -->
      <el-dialog title="编辑是否转正" :visible.sync="ZZdialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="ZZhandleClose">
        <el-form ref="formZZ" :model="ZZform" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="是否转正" prop="ijaRegularWorker">
              <el-radio-group v-model="ZZform.ijaRegularWorker">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="ZZhandleClose">取 消</el-button>
          <el-button type="primary" @click="ZZSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑个人简介 -->
      <el-dialog title="编辑个人简介" :visible.sync="JJdialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="JJhandleClose">
        <el-form ref="formJJ" :model="JJform" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="个人简介" prop="ijaIntroduction">
              <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 16 }" placeholder="请输入内容"
                v-model="JJform.ijaIntroduction" :rows="3">
              </el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="JJhandleClose">取 消</el-button>
          <el-button type="primary" @click="JJSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 编辑是否发offer -->
      <el-dialog title="是否发offer" :visible.sync="Offerdialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="OfferhandleClose">
        <el-form ref="formOffer" :model="Offerform" label-position="top" size="mini" label-width="150px" :rules="rules"
          style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="是否发offer" prop="ijaOffer">
              <el-radio-group v-model="Offerform.ijaOffer">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="身份证号" prop="ijaIdcard">
              <el-input v-model="Offerform.ijaIdcard" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="薪资描述" prop="ijaSalary">
              <el-input v-model="Offerform.ijaSalary" type="textarea" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>

            <el-form-item label="婉拒offer原因" prop="ijaOfferRefuseReason">
              <el-input v-model="Offerform.ijaOfferRefuseReason" type="textarea" style="width: 50%"
                placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="待入职时间" prop="ijaEntryDateAgree">
              <el-date-picker v-model="Offerform.ijaEntryDateAgree" type="date" value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="OfferhandleClose">取 消</el-button>
          <el-button type="primary" @click="OfferSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--离职 -->
      <el-dialog title="离职" :visible.sync="Leavedialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="LeavehandleClose">
        <el-form ref="formLeave" :model="Leaveform" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="离职原因" prop="ijaLeaveReason">
              <el-input v-model="Leaveform.ijaLeaveReason" type="textarea" style="width: 50%"
                placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="离职时间" prop="ijaLeaveDate">
              <el-date-picker v-model="Leaveform.ijaLeaveDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="LeavehandleClose">取 消</el-button>
          <el-button type="primary" @click="LeaveSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--邀约 -->
      <el-dialog title="邀约" :visible.sync="isItShow" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="IthandleClose">
        <el-form ref="formIt" :model="formIt" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="应聘岗位" prop="ijaPost">
              <el-select v-model="formIt.ijaPost" filterable placeholder="请选择" style="width: 200px">
                <el-option v-for="(item, index) in getIvJobApplicantPostList_data || []" :label="item.ijapName"
                  :value="item.ijapName" :key="item.ijapId"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邀约日期" prop="ijaDateInvite">
              <el-date-picker v-model="formIt.ijaDateInvite" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="手机号码" prop="ijaPhone">
              <el-input v-model="formIt.ijaPhone" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="面试日期" prop="ijaDateInterview">
              <el-date-picker v-model="formIt.ijaDateInterview" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
                style="width: 200px">
              </el-date-picker>
              <el-time-picker v-model="formIt.ijaTimeInterview" :format="'HH:mm'" value-format="HH:mm"
                placeholder="选择面试时间" style="width: 200px">
              </el-time-picker>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="IthandleClose">取 消</el-button>
          <el-button type="primary" @click="ItSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--复试 -->
      <el-dialog title="复试" :visible.sync="FSdialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="FShandleClose">
        <el-form ref="formFS" :model="FSform" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="复试官" prop="ijaInterviewAgain">
              <el-input v-model="FSform.ijaInterviewAgain" type="text" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="复试反馈" prop="ijaFeedbackInterviewAgain">
              <el-radio-group v-model="FSform.ijaFeedbackInterviewAgain">
                <el-radio label="通过">通过</el-radio>
                <el-radio label="未通过">未通过</el-radio>
                <el-radio label="留作业">留作业</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="FShandleClose">取 消</el-button>
          <el-button type="primary" @click="FSSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--一周留存 -->
      <el-dialog title="一周留存" :visible.sync="LCdialog" width="70%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="LChandleClose">
        <el-form ref="formLC" :model="LCform" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="一周留存" prop="ijaEntryWeek">
              <el-radio-group v-model="LCform.ijaEntryWeek">
                <el-radio label="是">是</el-radio>
                <el-radio label="否">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="LChandleClose">取 消</el-button>
          <el-button type="primary" @click="LCSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--权限 -->
      <el-dialog title="编辑权限" :visible.sync="QXdialog" width="30%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="QXhandleClose">
        <el-form ref="formQX" :model="QXform" label-position="left" label-width="120px" :rules="rules"
          style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="基础信息" prop="ijaAuthBase">
              <el-radio-group v-model="QXform.ijaAuthBase">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="到面信息" prop="ijaAuthFace">
              <el-radio-group v-model="QXform.ijaAuthFace">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="复试" prop="ijaAuthFaceAgain">
              <el-radio-group v-model="QXform.ijaAuthFaceAgain">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="offer情况" prop="ijaAuthOffer">
              <el-radio-group v-model="QXform.ijaAuthOffer">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否办理入职" prop="ijaAuthEntryStatus">
              <el-radio-group v-model="QXform.ijaAuthEntryStatus">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="一周留存" prop="ijaAuthEntryWeek">
              <el-radio-group v-model="QXform.ijaAuthEntryWeek">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否转正" prop="ijaAuthRegularWorker">
              <el-radio-group v-model="QXform.ijaAuthRegularWorker">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="离职" prop="ijaAuthLeave">
              <el-radio-group v-model="QXform.ijaAuthLeave">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="QXhandleClose">取 消</el-button>
          <el-button type="primary" @click="QXSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--申请权限 -->
      <el-dialog title="申请权限" :visible.sync="AFdialog" width="30%" top="8vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="AFhandleClose">
        <el-form ref="formAF" :model="AFform" label-position="left" label-width="120px" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item>
              <el-checkbox v-model="checked" @change="checkedChange(checked)">全部申请</el-checkbox>
            </el-form-item>
            <el-form-item label="基础信息" prop="ijaAuthBase">
              <el-radio-group v-model="AFform.ijaAuthBase">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="到面信息" prop="ijaAuthFace">
              <el-radio-group v-model="AFform.ijaAuthFace">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="复试" prop="ijaAuthFaceAgain">
              <el-radio-group v-model="AFform.ijaAuthFaceAgain">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="offer情况" prop="ijaAuthOffer">
              <el-radio-group v-model="AFform.ijaAuthOffer">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否办理入职" prop="ijaAuthEntryStatus">
              <el-radio-group v-model="AFform.ijaAuthEntryStatus">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio> </el-radio-group>``
            </el-form-item>
            <el-form-item label="一周留存" prop="ijaAuthEntryWeek">
              <el-radio-group v-model="AFform.ijaAuthEntryWeek">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="是否转正" prop="ijaAuthRegularWorker">
              <el-radio-group v-model="AFform.ijaAuthRegularWorker">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="离职" prop="ijaAuthLeave">
              <el-radio-group v-model="AFform.ijaAuthLeave">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="申请原因" prop="ijaaaApplyDes">
              <el-input v-model="AFform.ijaaaApplyDes" style="width: 60%" type="textarea"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="AFhandleClose">取 消</el-button>
          <el-button type="primary" @click="AFSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--编辑应聘者-隐藏录音和跟进反馈 -->
      <el-dialog title="隐藏录音和跟进反馈" :visible.sync="Ycdialog" width="20%" top="28vh" :close-on-press-escape="false"
        :close-on-click-modal="false" @close="YchandleClose">
        <el-form ref="formYc" :model="formYc" label-position="top" :rules="rules">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="是否隐藏录音和跟进反馈" prop="ijaHide">
              <el-radio-group v-model="formYc.ijaHide">
                <el-radio :label="2">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="YchandleClose">取 消</el-button>
          <el-button type="primary" @click="YcSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="背调详情" :visible.sync="isBackTone" width="70%" top="8vh">
        <el-descriptions :column="3" border :labelStyle="{
          color: '#409EFF',
          textAlign: 'center',
          width: '14%',
          fontSize: '12px',
        }" :contentStyle="{
          textAlign: 'center',
          width: '18%',
          fontSize: '12px',
        }">
          <el-descriptions-item label="应聘者">{{
            backToneData.ijaName
          }}</el-descriptions-item>
          <el-descriptions-item label="是否完成背调">{{
            backToneData.ijabProgress
          }}</el-descriptions-item>
          <el-descriptions-item label="未完成描述">{{
            backToneData.ijabProgressDes
          }}</el-descriptions-item>
          <el-descriptions-item label="学历匹配">{{
            backToneData.ijabEducation
          }}</el-descriptions-item>
          <el-descriptions-item label="学历不匹配描述">{{
            backToneData.ijabEducationDes
          }}</el-descriptions-item>
          <el-descriptions-item label="社保匹配">{{
            backToneData.ijabSocial
          }}</el-descriptions-item>
          <el-descriptions-item label="背调公司名">{{
            backToneData.ijabCompany
          }}</el-descriptions-item>
          <el-descriptions-item label="配合背调的联系人">{{
            backToneData.ijabContactUser
          }}</el-descriptions-item>
          <el-descriptions-item label="配合背调的联系人的岗位">{{
            backToneData.ijabContactPost
          }}</el-descriptions-item>
          <el-descriptions-item label="上级领导姓名">{{
            backToneData.ijabUpName
          }}</el-descriptions-item>
          <el-descriptions-item label="上级领导任职岗位">{{
            backToneData.ijabUpPost
          }}</el-descriptions-item>
          <el-descriptions-item label="联系电话">
            <template v-if="backToneData.ijabContactPhone">
              <div v-for="(item, index) in JSON.parse(backToneData.ijabContactPhone)" ::key="index">
                {{ item.value }}
              </div>
            </template>
          </el-descriptions-item>
          <el-descriptions-item label="不吻合记录">
            <template v-if="backToneData.ijabMismatchedDes">
              <div style="margin:10px" v-if="JSON.parse(backToneData.ijabMismatchedDes).ijabmTime">
                <span>时间</span>: <span>{{ JSON.parse(backToneData.ijabMismatchedDes).ijabmTime }} </span>
              </div>
              <div style="margin:10px" v-if="JSON.parse(backToneData.ijabMismatchedDes).ijabmPost">
                <span>岗位</span>: <span>{{ JSON.parse(backToneData.ijabMismatchedDes).ijabmPost }} </span>
              </div>
              <div style="margin:10px" v-if="JSON.parse(backToneData.ijabMismatchedDes).ijabmWorker">
                <span>工作内容</span>: <span>{{ JSON.parse(backToneData.ijabMismatchedDes).ijabmWorker }} </span>
              </div>
              <div style="margin:10px" v-if="JSON.parse(backToneData.ijabMismatchedDes).ijabmLever">
                <span>离职原因</span>: <span>{{ JSON.parse(backToneData.ijabMismatchedDes).ijabmLever }} </span>
              </div>
              <div style="margin:10px" v-if="JSON.parse(backToneData.ijabMismatchedDes).ijabmAbility">
                <span>工作能力</span>: <span>{{ JSON.parse(backToneData.ijabMismatchedDes).ijabmAbility }} </span>
              </div>
              <div style="margin:10px" v-if="JSON.parse(backToneData.ijabMismatchedDes).ijabmOther">
                <span>其他</span>: <span>{{ JSON.parse(backToneData.ijabMismatchedDes).ijabmOther }} </span>
              </div>
            </template>
          </el-descriptions-item>
        </el-descriptions>
      </el-dialog>
      <!--详情 -->
      <el-dialog title="详情" :visible.sync="isDetailDiaLog" width="70%" top="8vh">
        <div style="
            width: 100%;
            height: 100%;
            overflow-y: auto;
            padding: 50px 50px 15px;
            overflow-x: hidden;
          ">
          <el-descriptions :column="3" border :labelStyle="{
            color: '#409EFF',
            textAlign: 'center',
            width: '14%',
            fontSize: '12px',
          }" :contentStyle="{
            textAlign: 'center',
            width: '18%',
            fontSize: '12px',
          }">
            <el-descriptions-item label="应聘者">{{
              DetailStr.ijaName
            }}</el-descriptions-item>
            <el-descriptions-item label="应聘岗位">{{
              DetailStr.ijaPost
            }}</el-descriptions-item>
            <el-descriptions-item label="邀约日期">{{
              DetailStr.ijaDateInvite
            }}</el-descriptions-item>
            <el-descriptions-item label="招聘渠道">{{
              DetailStr.ijcName
            }}</el-descriptions-item>
            <el-descriptions-item label="手机号">{{
              DetailStr.ijaPhone
            }}</el-descriptions-item>
            <el-descriptions-item label="性别">{{
              DetailStr.ijaSex
            }}</el-descriptions-item>
            <el-descriptions-item label="学历">{{
              DetailStr.ijaEducationLevel
            }}</el-descriptions-item>
            <el-descriptions-item label="面试日期">{{
              DetailStr.ijaDateInterview
            }}</el-descriptions-item>
            <el-descriptions-item label="面试时间">{{
              DetailStr.ijaTimeInterview
            }}</el-descriptions-item>
            <!-- <el-descriptions-item label="面试评价(线上)">{{
              DetailStr.ijaFeedbackOnline
            }}</el-descriptions-item> -->
            <el-descriptions-item label="招聘官">{{
              DetailStr.iuName
            }}</el-descriptions-item>
            <el-descriptions-item label="面试登记表">
              <el-button v-if="DetailStr.ijaFileRegisterForm" size="mini" type="text"
                @click="gotoYuLan(DetailStr.ijaFileRegisterForm)">
                预览
              </el-button>
            </el-descriptions-item>
            <el-descriptions-item label="简历">
              <el-button v-if="DetailStr.ijaBiographicalNotes" size="mini" type="text"
                @click="gotoYuLan(DetailStr.ijaBiographicalNotes)">
                预览
              </el-button>
            </el-descriptions-item>
            <el-descriptions-item label="录音">
              <el-button v-if="DetailStr &&
                DetailStr.ivAudioList.length == 1 &&
                DetailStr.ivAudioList[0].iaPath != '***'
              " size="mini" type="text" @click="audioClick(DetailStr.ivAudioList[0])">
                播放
              </el-button>
              <el-button v-if="DetailStr && DetailStr.ivAudioList.length > 1" size="mini" type="text"
                @click="updataDetail(DetailStr)">
                详情
              </el-button>
            </el-descriptions-item>
          </el-descriptions>
          <!-- 到面 -->
          <div style="margin: 15px 0">
            <p>到面信息:</p>
            <el-descriptions :column="3" border :labelStyle="{
              color: '#409EFF',
              textAlign: 'center',
              width: '14%',
              fontSize: '12px',
            }" :contentStyle="{
              textAlign: 'center',
              width: '18%',
              fontSize: '12px',
            }">
              <el-descriptions-item label="是否到面">{{
                DetailStr.ijaFace
              }}</el-descriptions-item>
              <el-descriptions-item label="初始反馈">{{
                DetailStr.ijaFeedbackFirst
              }}</el-descriptions-item>
              <el-descriptions-item label="代面招聘">{{
                DetailStr.iuNameInstead
              }}</el-descriptions-item>
              <el-descriptions-item label="身份证">{{
                DetailStr.ijaIdcard
              }}</el-descriptions-item>
              <el-descriptions-item label="面试评价(线下)">{{
                DetailStr.ijaFeedbackFollow
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <!--复试  -->
          <div style="margin: 15px 0">
            <p>复试信息:</p>
            <el-descriptions :column="3" border :labelStyle="{
              color: '#409EFF',
              textAlign: 'center',
              width: '14%',
              fontSize: '12px',
            }" :contentStyle="{
              textAlign: 'center',
              width: '18%',
              fontSize: '12px',
            }">
              <el-descriptions-item label="复试官">{{
                DetailStr.ijaInterviewAgain
              }}</el-descriptions-item>
              <el-descriptions-item label="复试反馈">{{
                DetailStr.ijaFeedbackInterviewAgain
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <!--发放offer  -->
          <div style="margin: 15px 0">
            <p>发放offer:</p>
            <el-descriptions :column="3" border :labelStyle="{
              color: '#409EFF',
              textAlign: 'center',
              width: '14%',
              fontSize: '12px',
            }" :contentStyle="{
              textAlign: 'center',
              width: '18%',
              fontSize: '12px',
            }">
              <el-descriptions-item label="是否发放offer">{{
                DetailStr.ijaOffer
              }}</el-descriptions-item>
              <el-descriptions-item label="薪资描述">{{
                DetailStr.ijaSalary
              }}</el-descriptions-item>
              <el-descriptions-item label="婉拒offer原因">{{
                DetailStr.ijaOfferRefuseReason
              }}</el-descriptions-item>
              <el-descriptions-item label="待入职时间">{{
                DetailStr.ijaEntryDateAgree
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <!--入职手续  -->
          <div style="margin: 15px 0">
            <p>入职手续:</p>
            <el-descriptions :column="3" border :labelStyle="{
              color: '#409EFF',
              textAlign: 'center',
              width: '14%',
              fontSize: '12px',
            }" :contentStyle="{
              textAlign: 'center',
              width: '18%',
              fontSize: '12px',
            }">
              <el-descriptions-item label="是否办理入职">{{
                DetailStr.ijaEntryStatus
              }}</el-descriptions-item>
              <el-descriptions-item label="不来报到原因">{{
                DetailStr.ijaEntryRefuseReason
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <!--一周留存  -->
          <div style="margin: 15px 0">
            <p>一周留存:</p>
            <el-descriptions :column="3" border :labelStyle="{
              color: '#409EFF',
              textAlign: 'center',
              width: '14%',
              fontSize: '12px',
            }" :contentStyle="{
              textAlign: 'center',
              width: '18%',
              fontSize: '12px',
            }">
              <el-descriptions-item label="一周留存">{{
                DetailStr.ijaEntryWeek
              }}</el-descriptions-item>
              <el-descriptions-item label="是否转正">{{
                DetailStr.ijaRegularWorker
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
          <!--离职  -->
          <div style="margin: 15px 0">
            <p>离职:</p>
            <el-descriptions :column="3" border :labelStyle="{
              color: '#409EFF',
              textAlign: 'center',
              width: '14%',
              fontSize: '12px',
            }" :contentStyle="{
              textAlign: 'center',
              width: '18%',
              fontSize: '12px',
            }">
              <el-descriptions-item label="离职时间">{{
                DetailStr.ijaLeaveDate
              }}</el-descriptions-item>
              <el-descriptions-item label="离职原因">{{
                DetailStr.ijaLeaveReason
              }}</el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </el-dialog>
      <!--编辑录音 -->
      <el-dialog title="编辑面试录音(录音标题中的日期会自动获取面试时间)" :visible.sync="MSdialog" width="70%" top="8vh">
        <el-form ref="formMS" :model="formMS" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="录音地址" prop="iaPath">
              <my-upload ref="OtherImgupload" @fileChange="OtherImgChange" :filearr="OtherImgfileList"
                :limit="OtherImglimit" style="margin: 10px 5px 5px" type="text"
                accept=".mp3,.flac,.ogg,.cd,.cda,.ape,.asf,.rm,
                                .mov,.amr,.realaudio,.pcm,.avi,.3gp,.mkv,.vbr,.vqf,.aiff,.aif,.oggvorbis,.au,.m4a,.aac,.x-m4a,.mpeg,.mpeg-4,.adts,.wav,.wave,.wma,.midi,.mid">
              </my-upload>
              <el-input disabled v-model="formMS.iaPath" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="MShandleClose">取 消</el-button>
          <el-button type="primary" @click="MSSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--编辑简历 -->
      <el-dialog title="编辑简历" :visible.sync="JLdialog" width="70%" top="8vh">
        <el-form ref="formJL" :model="formJL" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="简历地址" prop="ijaBiographicalNotes">
              <my-uploadLoaction ref="JLOtherImgupload" @fileChange="JLOtherImgChange" :filearr="JLOtherImgfileList"
                :limit="JLOtherImglimit" style="margin: 10px 5px 5px" type="text">
              </my-uploadLoaction>
              <el-input disabled v-model="formJL.ijaBiographicalNotes" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="JLhandleClose">取 消</el-button>
          <el-button type="primary" @click="JLSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!--编辑面试登记表 -->
      <el-dialog title="编辑面试登记表" :visible.sync="Djbdialog" width="70%" top="8vh">
        <el-form ref="formDjb" :model="formDjb" label-position="top" :rules="rules" style="height: 65vh">
          <div style="
              width: 100%;
              height: 100%;
              overflow-y: auto;
              padding: 50px 50px 15px;
              overflow-x: hidden;
            ">
            <el-form-item label="登记表地址" prop="ijaFileRegisterForm">
              <my-uploadLoaction ref="DjbOtherImgupload" @fileChange="DjbOtherImgChange" :filearr="DjbOtherImgfileList"
                :limit="DjbOtherImglimit" style="margin: 10px 5px 5px" type="text">
              </my-uploadLoaction>
              <el-input disabled v-model="formDjb.ijaFileRegisterForm" style="width: 50%" placeholder="请输入"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="DjbhandleClose">取 消</el-button>
          <el-button type="primary" @click="DjbSureBtn">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 批量导入 -->
      <el-dialog title="批量导入" :visible.sync="bulkImport" width="90%" :before-close="bulkImportClose"
        style="margin-left: 200px">
        <div style="margin: 0 10px 10px; display: flex">
          <el-upload class="upload-demo" action="#" accept=".xlsx,.xls" :on-change="updatabulk" :auto-upload="false"
            ref="bulk" multiple>
            <el-button size=" medium" type="danger">点击上传</el-button>
          </el-upload>
          <div>
            <el-button type="primary" @click="
              downloadFile(
                'https://trainapp.aojuai.com/interview/excel/application.xlsx',
                '应聘者模板'
              )
              " style="margin-left: 20%; height: 40px">下载模板</el-button>
          </div>
        </div>
        <div>
          <ve-table :columns="columnsImport" :table-data="bulkData" :max-height="500" :border-x="true" :border-y="true"
            :scrollWidth="10" row-key-field-name="dataIndex" :cell-style-option="cellStyleOption" style="width: 100%" />
          <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
        </div>
        <div style="margin: 10px; font-size: 18px" v-if="bulkData.length != 0">
          <span style="color: #0080ff">一共{{ importData.numAll }}条;</span>
          <span style="color: #0e9a00; margin-left: 5px">成功{{ importData.numSuccess }}条;</span>
          <span style="color: red; margin-left: 5px">失败{{ importData.numFail }}条</span>
          <span style="color: #e6a23c; margin-left: 5px">信息不完整{{ importData.numUnWhole }}条</span>
        </div>
        <div slot="footer" class="dialog-footer" style="width: 80%; margin: 10px auto">
          <!-- <el-button @click="bulkImportClose">取 消</el-button> -->
          <el-button type="success" @click="bulkImportClick">确定导入</el-button>
        </div>
      </el-dialog>
      <el-dialog title="录音列表" :visible.sync="myFileList" width="90%" style="margin-left: 200px">
        <div style="display: flex; flex-direction: row-reverse">
          <el-button type="success" @click="updataAudio(fileList)">新增录音</el-button>
        </div>
        <div>
          <ve-table :columns="columnsFile" :table-data="MyFileData" :max-height="500" :border-x="true" :border-y="true"
            :scrollWidth="10" row-key-field-name="dataIndex" :cell-style-option="cellStyleOption" style="width: 100%" />
          <div v-show="bulkData.length == 0" class="empty-data">暂无数据</div>
        </div>
      </el-dialog>
      <el-dialog title="申请列表" :visible.sync="AFdataShow" width="90%" style="margin-left: 200px">
        <div style="display: flex; flex-direction: row-reverse">
          <!-- <el-button type="success" @click="updataAudio(fileList)">新增录音</el-button> -->
        </div>
        <div>
          <ve-table :columns="columnsAF" :table-data="MyAFData" :max-height="500" :border-x="true" :border-y="true"
            :scrollWidth="10" row-key-field-name="dataIndex" :cell-style-option="cellStyleOption" style="width: 100%" />
          <div v-show="MyAFData.length == 0" class="empty-data">暂无数据</div>
          <div class="table-pagination">
            <ve-pagination :total="AFtotalCount" :page-index="AFformDatas.currentPage" :page-size="AFformDatas.pageSize"
              :page-size-option="[10, 20, 40, 80, 160, 320, 640, 1000, 2000]"
              @on-page-number-change="AFpageNumberChange" @on-page-size-change="AFpageSizeChange" />
          </div>
        </div>
      </el-dialog>
      <!-- 线上面试 -->
      <el-dialog title="详情" :visible.sync="isDetail" width="70%" top="8vh" :before-close="detailClose">
        <el-card style="width: 95%;margin: 15px auto;">
          <div style="font-size: 20px;font-weight: 600;color: #409EFF;width: 95%;margin: 10px auto;">
            视频回答
          </div>
          <ve-table ref="vetableVideo" v-if="detailTable.ivOnlineInterviewItemList" :columns="columnVideo"
            :table-data="detailTable.ivOnlineInterviewItemList" :max-height="300" :border-x="true" :border-y="true"
            :scrollWidth="10" :cell-style-option="cellStyleOption" :checkbox-option="checkboxOption"
            row-key-field-name="ioiiId" :cellSelectionOption="cellSelectionOption" style="width: 100%"
            :editOption="editOption" />
          <div v-show="detailTable.ivOnlineInterviewItemList == 0" class="empty-data">暂无数据</div>
        </el-card>
        <el-card style="width: 95%;margin: 15px auto;">
          <div style="font-size: 20px;font-weight: 600;color: #409EFF;width: 95%;margin: 10px auto;">
            辨色测试
          </div>
          <div class="textclass" v-if="detailTable.ivqPaperRecordEye"
            style="width: 95%;height: 350px;overflow-y: auto;margin: 15px auto;overflow-x: hidden;">
            <div id="" v-for="(item, index) in detailTable.ivqPaperRecordEye.ivqPaperTopicList || []" :key="index">
              <p style="margin: 15px 0; font-size: 16px">
                {{ index + 1 }}.({{ item.qttName }}){{ item.qtName }}
              </p>
              <img style="height: 200px;" :src="item.qtImg" alt="">
              <el-radio-group v-model="SMcheckList[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                v-for="(topic, n) in item.ivqTopicItemList" :key="n" style="display: block" text-color="red">
                <el-radio :label="topic.qtiId" style="margin: 5px" size="medium" border v-model="item.qptAnswerIds"
                  disabled>{{
                    topic.qtiValue }}</el-radio>
              </el-radio-group>
              <div :style="{ 'color': item.qtScoreRight == 1 ? '#F56C6C' : '#67C23A' }">{{ item.qtScoreRight == 1 ? '错误'
                :
                '正确' }}
              </div>
            </div>
          </div>
        </el-card>

        <el-card style="width: 95%;margin: 15px auto;">
          <div style="font-size: 20px;font-weight: 600;color: #409EFF;width: 95%;margin: 10px auto;">
            职业锚
          </div>
          <div v-if="detailTable.ivqPaperRecordTwo" style="padding: 0 50px">
            <el-collapse>
              <el-collapse-item v-for="(item, index) in detailTable.ivqPaperRecordTwo.iprResultTwoList || []">
                <template slot="title">
                  <p style="width: 100%">
                    <span style="color: red"> {{ item.score }}分 </span>
                    <span style="margin-left: 15px">{{ item.title }}</span>
                  </p>
                </template>
                <p>
                  {{ item.description }}
                </p>
              </el-collapse-item>
            </el-collapse>
          </div>
          <div class="textclass" v-if="detailTable.ivqPaperRecordTwo"
            style="width: 95%;height: 350px;overflow-y: auto;margin: 15px auto;overflow-x: hidden;">
            <div id="" v-for="(item, index) in detailTable.ivqPaperRecordTwo.ivqPaperTopicList || []" :key="index">
              <p style="margin: 15px 0; font-size: 16px">
                {{ index + 1 }}.({{ item.qttName }}){{ item.qtName }}
              </p>
              <el-radio-group v-model="ZYMcheckList[index][0]" v-if="item.qttId != 2 && item.qttId != 4"
                v-for="(topic, n) in item.ivqTopicItemList" :key="n" style="display: block" text-color="red">
                <el-radio :label="topic.qtiId" style="margin: 5px" size="medium" border v-model="item.qptAnswerIds"
                  disabled>{{
                    topic.qtiValue }}</el-radio>
              </el-radio-group>

            </div>
          </div>
        </el-card>
      </el-dialog>
      <!-- 关联面试记录弹框 -->
      <el-dialog title="选择签到记录" :visible.sync="associateDialogVisible" width="40%" top="8vh"
        :close-on-press-escape="false" :close-on-click-modal="false" @close="associateDialogClose">
        <el-form label-width="80px">
          <el-form-item label="签到记录">
            <el-select v-model="selectedInterviewRecord" placeholder="请选择签到记录" clearable style="width: 100%">
              <el-option v-for="item in interviewRecordList" :key="item.iiaId"
                :label="`${item.name} - ${item.phone} - ${item.createtime}`" :value="item.iiaId"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="associateDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmAssociate">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <div style="
        width: 85%;
        position: fixed;
        bottom: 5px;
        left: 13%;
        background-color: white;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        z-index: 9999;
      " v-if="audioShow">
      <i class="el-icon-close" style="margin-left: 95%" @click="audioShow = false"></i>
      <aplayer :music="audio[0]" fixed v-if="audio.length > 0" autoplay @ended="onEnded" />
    </div>
    <div style="width: 100%;height: 100%;position: fixed;top: 0;left: 0;z-index: 99999;background-color: black;"
      v-if="isVideo">
      <div style="width: 100%;height:100%;overflow: hidden;position: relative;">
        <video controls :src="videofile" style="width: 100%;height: 100%;"></video>
        <div style="width: 50px;height: 50px;background-color:rgba(255, 5, 5,0.5);line-height: 50px;text-align: center;
              border-radius: 100%;font-size: 23px;color: white;position:absolute;top: -15px;right: -15px;"
          @click.capture.stop="videoPreViewClose()" v-if="videofile != ''">
          ✖
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import axios from "axios";
import config from "../../api/env.js";
import COS from "cos-js-sdk-v5";
import {
  getIvJobApplicantBackgroundOne,
  getIvJobApplicantAuthApplyNums,
  updateIvJobApplicantIntroduction,
  addIvJobApplicantAuthApply,
  getIvJobApplicantAuthApplyList,
  updateIvJobApplicantAuthApplyStatus,
  updateIvJobApplicantAuthApplyStatusCancel,
  addIvJobApplicant,
  deleteIvJobApplicant,
  getIvJobApplicantList,
  updateIvJobApplicant,
  updateIvJobApplicantRegularWorker,
  updateIvJobApplicantOffer,
  getIvJobChannelList,
  updateIvJobApplicantEntryStatus,
  getIvUserList,
  updateIvJobApplicantToFace,
  updateIvJobApplicantLeave,
  updateIvJobApplicantInterviewAgain,
  getIvJobApplicantDetails,
  updateIvJobApplicantFileRegisterForm,
  updateIvJobApplicantBiographicalNotes,
  deleteIvAudio,
  uploadNcIvJobApplicant,
  uploadImportIvJobApplicant,
  updateIvJobApplicantEntryWeek,
  updateIvJobApplicantHide,
  updateIvJobApplicantAll,
  addIvAudio,
  getIvAudioList,
  getIvqPaperRecordDetails,
  getIvJobApplicantWareListMine,
  getIvNoticeList,
  getIvNoticeUnReadNum,
  addIvJobApplicantRecord,
  getIvJobApplicantRecordList,
  updateIvJobApplicantOwner,
  getIvOnlineInterviewDetailsOne,
  updateIvInterviewApplicantSignUser,
  getIvInterviewApplicantList,
  getPolicyTxCloudInterview,
  getIvJobApplicantPostList,
} from "../../api/api";
let Base64 = require("js-base64").Base64;
import aplayer from "vue-aplayer";
import { mapMutations } from "vuex";
// 面试日历子组件（月/周视图，日历图模式专用）
import ApplicantCalendar from "./applicantCalendar.vue";
export default {
  name: "",
  components: {
    aplayer,
    ApplicantCalendar,
  },
  data() {
    return {
      Djbdialog: false,
      formDjb: {},
      DjbOtherImgfileList: [],
      DjbOtherImglimit: 1,
      backToneData: '',
      isBackTone: false,
      detailTable: '',
      isVideo: false,
      videofile: '',
      isDetail: false,
      ioiId: '',
      SMcheckList: [],
      ZYMcheckList: [],
      columnVideo: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: 'left',
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "iowText",
          key: "iowText",
          title: "问题",
          width: 350,
          align: "center",
          edit: false,
          fixed: 'left',
        },
        {
          field: "ioiiAnswerPath",
          key: "ioiiAnswerPath",
          title: "回答视频",
          width: 100,
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  <div style="color:red;" on-click={() => this.videoPreView(row.ioiiAnswerPath)}> 预览</div>
                }
              </span>
            );
          },
        },

      ],
      IsIuShow: false,
      iuIds: "",
      columnIv: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          fixed: "left",
          field: "iuName",
          key: "iuName",
          title: "招聘",
          width: 80,
          align: "center",
        },

        {
          field: "ijaName",
          key: "ijaName",
          title: "应聘者",
          width: 90,
          fixed: "left",
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.getDetail(row.ijaId)}
                >
                  {row.ijaName}
                </el-button>
              </span>
            );
          },
        },
        {
          field: "ijaPost",
          key: "ijaPost",
          // fixed: 'left',
          title: "应聘岗位",
          width: 120,
          align: "center",
          edit: false,
        },
        {
          field: "ijaDateInvite",
          key: "ijaDateInvite",
          title: "邀约日期",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijcName",
          key: "ijcName",
          title: "招聘渠道",
          width: 110,
          align: "center",
          edit: false,
        },
        {
          field: "ijaRecommended",
          key: "ijaRecommended",
          title: "内推人",
          width: 110,
          align: "center",
          edit: false,
        },
        {
          field: "ijaPhone",
          key: "ijaPhone",
          title: "手机号码",
          width: 110,
          align: "center",
          edit: false,
        },
        {
          field: "ijaSex",
          key: "ijaSex",
          title: "性别",
          width: 60,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEducationLevel",
          key: "ijaEducationLevel",
          title: "学历",
          width: 80,
          align: "center",
          edit: false,
        },

        {
          field: "ijaDateInterview",
          key: "ijaDateInterview",
          title: "面试日期",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijaTimeInterview",
          key: "ijaTimeInterview",
          title: "面试时间",
          width: 60,
          align: "center",
          edit: false,
        },
        // 到面
        {
          field: "ijaFace",
          key: "ijaFace",
          title: "是否到面",
          width: 60,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackFirst",
          key: "ijaFeedbackFirst",
          title: "初试反馈",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaAudio",
          key: "ijaAudio",
          title: "面试录音",
          width: 120,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.ivAudioList.length == 1 &&
                  row.ivAudioList[0].iaPath != "***" ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.audioClick(row.ivAudioList[0])}
                  >
                    播放
                  </el-button>
                ) : (
                  ""
                )}
                {row.ivAudioList.length > 0 ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.updataDetail(row)}
                  >
                    详情
                  </el-button>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          field: "ijaBiographicalNotes",
          key: "ijaBiographicalNotes",
          title: "简历",
          width: 120,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.ijaBiographicalNotes ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() =>
                      window.open(
                        `https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(
                          Base64.encode(row.ijaBiographicalNotes)
                        )}`
                      )
                    }
                  >
                    预览
                  </el-button>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          field: "iuNameInstead",
          key: "iuNameInstead",
          title: "代面招聘",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaIdcard",
          key: "ijaIdcard",
          title: "身份证号",
          width: 140,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackFollow",
          key: "ijaFeedbackFollow",
          title: "面试评价(线下)",
          width: 500,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },
        // 复试
        {
          field: "ijaInterviewAgain",
          key: "ijaInterviewAgain",
          title: "复试官",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackInterviewAgain",
          key: "ijaFeedbackInterviewAgain",
          title: "复试反馈",
          width: 90,
          align: "center",
          edit: false,
        },
        // 发放offer
        {
          field: "ijaOffer",
          key: "ijaOffer",
          title: "是否发offer",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijaSalary",
          key: "ijaSalary",
          title: "薪资描述",
          width: 180,
          align: "center",
          edit: false,
        },
        {
          field: "ijaOfferRefuseReason",
          key: "ijaOfferRefuseReason",
          title: "婉拒offer原因",
          width: 200,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },
        {
          field: "ijaEntryDateAgree",
          key: "ijaEntryDateAgree",
          title: "待入职时间",
          width: 90,
          align: "center",
          edit: false,
        },
        // 入职手续
        {
          field: "ijaEntryStatus",
          key: "ijaEntryStatus",
          title: "是否办理入职手续",
          width: 120,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEntryRefuseReason",
          key: "ijaEntryRefuseReason",
          title: "不来报到原因",
          width: 200,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },
        // 一周留存是否转正
        {
          field: "ijaIntroduction",
          key: "ijaIntroduction",
          title: "个人简介",
          width: 300,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEntryWeek",
          key: "ijaEntryWeek",
          title: "一周留存",
          width: 80,
          align: "center",
          edit: false,
        },
        {
          field: "ijaRegularWorker",
          key: "ijaRegularWorker",
          title: "是否转正",
          width: 80,
          align: "center",
          edit: false,
        },
        // 离职
        {
          field: "ijaLeaveDate",
          key: "ijaLeaveDate",
          title: "离职时间",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijaLeaveReason",
          key: "ijaLeaveReason",
          title: "离职原因",
          width: 200,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },

        // { field: "createusername", key: "createusername", title: "创建人", width: 160, align: "center" },
        // 签到关联

        {
          field: "createtime",
          key: "c",
          title: "创建时间",
          width: 160,
          align: "center",
        },
      ],
      IsIvRecord: false,
      IvRecordData: [],
      // 关联面试记录弹框
      associateDialogVisible: false,
      interviewRecordList: [],
      selectedInterviewRecord: null,
      currentAssociateRow: null,
      AFformDatas: {
        currentPage: 1,
        pageSize: 10,
      },
      AFtotalCount: "",
      getIvJobApplicantWareList_data: [],
      isTalent: false,
      AfNums: "",
      checked: false,
      columnsAF: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          fixed: "left",
          field: "createusername",
          key: "createusername",
          title: "招聘",
          width: 80,
          align: "center",
        },
        {
          fixed: "left",
          field: "ijaName",
          key: "ijaName",
          title: "应聘者",
          width: 80,
          align: "center",
        },
        {
          field: "ijaAuthBase",
          key: "ijaAuthBase",
          title: "基础信息",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthBase == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaAuthFace",
          key: "ijaAuthFace",
          title: "到面信息",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthFace == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaAuthFaceAgain",
          key: "ijaAuthFaceAgain",
          title: "复试",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthFaceAgain == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaAuthOffer",
          key: "ijaAuthOffer",
          title: "offer情况",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthOffer == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaAuthEntryStatus",
          key: "ijaAuthEntryStatus",
          title: "是否办理入职手续",
          width: 100,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthEntryStatus == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaAuthEntryWeek",
          key: "ijaAuthEntryWeek",
          title: "一周留存",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthEntryWeek == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaAuthRegularWorker",
          key: "ijaAuthRegularWorker",
          title: "是否转正",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthRegularWorker == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaAuthLeave",
          key: "ijaAuthLeave",
          title: "离职",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row.ijaAuthLeave == 2 ? "是" : "否";
          },
        },
        {
          field: "ijaaaApplyDes",
          key: "ijaaaApplyDes",
          title: "申请原因",
          width: 120,
          align: "center",
        },
        {
          field: "createtime",
          key: "createtime",
          title: "申请时间",
          width: 120,
          align: "center",
        },
        {
          field: "ijaaaStatus",
          key: "ijaaaStatus",
          title: "权限状态",
          width: 80,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.ijaaaStatus == 1 ? (
                  <el-tag size="mini" type="danger">
                    待处理
                  </el-tag>
                ) : row.ijaaaStatus == 2 ? (
                  <el-tag size="mini" type="success">
                    通过
                  </el-tag>
                ) : row.ijaaaStatus == 3 ? (
                  <el-tag size="mini" type="warning">
                    拒绝
                  </el-tag>
                ) : (
                  <el-tag size="mini" type="info">
                    取消
                  </el-tag>
                )}
              </span>
            );
          },
        },
        {
          field: "c",
          key: "c",
          title: "操作",
          width: 90,
          fixed: "left",
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {this.postid == 2 && row.ijaaaStatus == 1 ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.afPostClick(row)}
                  >
                    通过
                  </el-button>
                ) : (
                  ""
                )}
                {this.postid == 2 && row.ijaaaStatus == 1 ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.UnafPostClick(row)}
                  >
                    拒绝通过
                  </el-button>
                ) : (
                  ""
                )}
                {this.postid != 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.afCloseClick(row)}
                  >
                    取消
                  </el-button>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
      ],
      MyAFData: [],
      isItShow: false,
      formIt: {
        ijaId: "",
        ijaPost: "",
        ijaDateInvite: "",
        ijaPhone: "",
        ijaDateInterview: "",
        ijaTimeInterview: "",
      },
      AFdataShow: false,
      AFform: {
        ijaId: "",
        ijaAuthBase: "",
        ijaAuthFace: "",
        ijaAuthFaceAgain: "",
        ijaAuthOffer: "",
        ijaAuthEntryStatus: "",
        ijaAuthEntryWeek: "",
        ijaAuthRegularWorker: "",
        ijaAuthLeave: "",
        ijaaaApplyDes: "",
      },
      AFdialog: false,
      checkList: [],
      isText: false,
      topicArr: [],
      education: "全日制",
      fileList: "",
      myFileList: false,
      MyFileData: [],
      QXdialog: false,
      QXform: {},
      userid: "",
      Ycdialog: false,
      formYc: {},
      JJdialog: false,
      JJform: {},
      IsSerch: false,
      sitId: "",
      importData: "",
      bulkDataCopy: [],
      bulkData: [],
      bulkImport: false,
      JLOtherImglimit: 1,
      JLOtherImgfileList: [],
      JLdialog: false,
      formJL: {},
      audioShow: false,
      audio: [],
      OtherImglimit: 1,
      addLimit: 9,
      OtherImgfileList: [],
      MSdialog: false,
      formMS: {},
      DetailStr: "",
      isDetailDiaLog: false, //详情
      LCdialog: false, //留存
      LCform: {},
      FSdialog: false, //复试
      FSform: {},
      Leavedialog: false, //离职
      Leaveform: {},
      Offerdialog: false, //发放offer
      Offerform: {},
      ZZdialog: false, //转正
      ZZform: {},
      Facedialog: false, //到面
      Faceform: {},
      getIvUserList_data: [],
      getIvUserList_dataTwo: [],
      RZdialog: false, //入职
      RZform: {},
      getIvJobChannelList_data: [],
      getIvJobApplicantPostList_data: [],
      postForm: {},
      userarr: [],
      level_Four: [],
      level_Three: [],
      key: "ijaId",
      dialog: false,
      edit: false,
      form: {
        ijaPost: "",
        ijaBaseCity: "",
        ijaDateInvite: "",
        ijcId: "",
        ijaName: "",
        ijaPhone: "",
        ijaSex: "",
        ijaEducationLevel: "",
        ijaDateInterview: "",
        ijaTimeInterview: "",
        ijaRecommended: "",
        ijawId: "",
        hasOnline: 1,
      },
      rules: {
        ijaPost: [
          { required: true, message: "请选择应聘岗位", trigger: "blur" },
        ],
        ijaDateInvite: [
          { required: true, message: "请选择邀约日期", trigger: "change" },
        ],
        ijcId: [
          { required: true, message: "请选择招聘渠道", trigger: "change" },
        ],
        ijaName: [{ required: true, message: "请输入应聘者", trigger: "blur" }],
        ijaSex: [{ required: true, message: "请选择性别", trigger: "change" }],
        ijaPhone: [
          { required: true, message: "请选择手机号", trigger: "blur" },
        ],
        ijaEducationLevel: [
          { required: true, message: "请选择学历", trigger: "blur" },
        ],
        ijaDateInterview: [
          { required: true, message: "请选择日期", trigger: "change" },
        ],
        ijaTimeInterview: [
          { required: true, message: "请选择面试时间", trigger: "change" },
        ],
        ijaFace: [{ required: true, message: "请选择", trigger: "change" }],
        ijaFeedbackFirst: [
          { required: true, message: "请选择初试反馈", trigger: "change" },
        ],
        ijaRegularWorker: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        ijaOffer: [{ required: true, message: "请选择", trigger: "change" }],
        ijaLeaveDate: [
          { required: true, message: "请选择离职时间", trigger: "change" },
        ],
        ijaFeedbackInterviewAgain: [
          { required: true, message: "请选择复试反馈", trigger: "change" },
        ],
        ijaInterviewAgain: [
          { required: true, message: "请选择复试官", trigger: "blur" },
        ],
        ijaEntryWeek: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        // ijaEntryStatus: [
        //   { required: true, message: "请选择", trigger: "change" },
        // ],
      },
      // 未编辑前的值
      lastValue: "",
      // 单元格编辑功能
      editOption: {
        beforeCellValueChange: ({ row, column, changeValue }) => {
          this.beforeCellValChange(row, column, changeValue);
        },
        afterCellValueChange: ({ row, column, changeValue }) => {
          this.afterCellValChange(row, column, changeValue);
        },
      },
      cellSelectionOption: {
        // disble cell selection
        enable: true,
      },
      totalCount: 100,
      pageIndex: 1,
      pageSize: 10,
      selectedRowKeysCollection: [],
      checkboxOption: {
        // 可控属性
        selectedRowKeys: [],
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          this.changeSelectedRowKeys(row, isSelected, this.key);
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          this.changeSelectAll(isSelected, selectedRowKeys, this.key);
        },
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },
      windheight: "",
      tableHight: 520,
      columnsFile: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          fixed: "left",
          field: "ijaName",
          key: "ijaName",
          title: "应聘者",
          width: 80,
          align: "center",
        },
        {
          fixed: "left",
          field: "iaTitle",
          key: "iaTitle",
          title: "标题",
          width: 80,
          align: "center",
        },
        {
          field: "c",
          key: "c",
          title: "操作",
          width: 90,
          fixed: "left",
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.iaPath && row.iaPath != "***" ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.audioClick(row)}
                  >
                    播放
                  </el-button>
                ) : (
                  ""
                )}
                {row.iaPath != "***" ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.handleDelete2(row)}
                  >
                    删除
                  </el-button>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
      ],
      columns: [
        {
          field: "",
          key: "checkbox",
          // type=checkbox
          type: "checkbox",
          fixed: "left",
          title: "",
          width: 50,
          align: "center",
        },
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          fixed: "left",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          fixed: "left",
          field: "createusername",
          key: "createusername",
          title: "招聘",
          width: 80,
          align: "center",
        },

        {
          field: "ijaName",
          key: "ijaName",
          title: "应聘者",
          width: 90,
          fixed: "left",
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.getDetail(row.ijaId)}
                >
                  {row.ijaName}
                </el-button>
              </span>
            );
          },
        },
        {
          field: "ijaPost",
          key: "ijaPost",
          // fixed: 'left',
          title: "应聘岗位",
          width: 120,
          align: "center",
          edit: false,
        },
         {
          field: "ijaBaseCity",
          key: "ijaBaseCity",
          title: "base城市",
          width: 110,
          align: "center",
          edit: false,
        },
         {
          field: "ijaEntryDateAgree",
          key: "ijaEntryDateAgree",
          title: "待入职时间",
          width: 110,
          align: "center",
          edit: false,
        },
         {
          field: "ijaSex",
          key: "ijaSex",
          title: "性别",
          width: 60,
          align: "center",
          edit: false,
        },
        {
          field: "ijaDateInvite",
          key: "ijaDateInvite",
          title: "邀约日期",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijcName",
          key: "ijcName",
          title: "招聘渠道",
          width: 110,
          align: "center",
          edit: false,
        },
        {
          field: "ijaRecommended",
          key: "ijaRecommended",
          title: "内推人",
          width: 110,
          align: "center",
          edit: false,
        },
        {
          field: "ijaSignStatus",
          key: "ijaSignStatus",
          title: "签到关联状态",
          width: 110,
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return h('div', [
              row.ijaSignStatus == 2
                ? h('span', { style: { color: '#67C23A' } }, '已关联')
                : h('el-button', {
                  props: { type: 'text', size: 'mini', },
                  on: { click: () => this.openAssociateDialog(row) }
                }, '未关联')
            ]);
          }
        },
        {
          field: "ijaPhone",
          key: "ijaPhone",
          title: "手机号码",
          width: 110,
          align: "center",
          edit: false,
        },
       
        {
          field: "ijaEducationLevel",
          key: "ijaEducationLevel",
          title: "学历",
          width: 80,
          align: "center",
          edit: false,
        },

        {
          field: "ijaDateInterview",
          key: "ijaDateInterview",
          title: "面试日期",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijaTimeInterview",
          key: "ijaTimeInterview",
          title: "面试时间",
          width: 60,
          align: "center",
          edit: false,
        },
        // {
        //   field: "ijaFeedbackOnline",
        //   key: "ijaFeedbackOnline",
        //   title: "面试评价(线上)",
        //   width: 400,
        //   align: "center",
        //   edit: false,
        // },
        // 到面
        {
          field: "ijaFace",
          key: "ijaFace",
          title: "是否到面",
          width: 60,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackFirst",
          key: "ijaFeedbackFirst",
          title: "初试反馈",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaAudio",
          key: "ijaAudio",
          title: "面试录音",
          width: 120,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.ivAudioList.length == 1 &&
                  row.ivAudioList[0].iaPath != "***" ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.audioClick(row.ivAudioList[0])}
                  >
                    播放
                  </el-button>
                ) : (
                  ""
                )}
                {row.ivAudioList.length == 0 ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.updataAudio(row)}
                  >
                    新增录音
                  </el-button>
                ) : (
                  ""
                )}

                {row.ivAudioList.length > 0 ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() => this.updataDetail(row)}
                  >
                    详情
                  </el-button>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
        {
          field: "ijaBiographicalNotes",
          key: "ijaBiographicalNotes",
          title: "简历",
          width: 140,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.ijaBiographicalNotes ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() =>
                      window.open(
                        `https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(
                          Base64.encode(row.ijaBiographicalNotes)
                        )}`
                      )
                    }
                  >
                    预览
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaBiographicalNotes ? <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.downloadJl(row.ijaBiographicalNotes)}
                >
                  下载
                </el-button> : ''
                }
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.updataJl(row.ijaId)}
                >
                  编辑
                </el-button>
              </span>
            );
          },
        },
        {
          field: "ijaFileRegisterForm",
          key: "ijaFileRegisterForm",
          title: "面试登记表",
          width: 140,
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {row.ijaFileRegisterForm ? (
                  <el-button
                    size="mini"
                    type="text"
                    on-click={() =>
                      window.open(
                        `https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(
                          Base64.encode(row.ijaFileRegisterForm)
                        )}`
                      )
                    }
                  >
                    预览
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaFileRegisterForm ? <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.downloadDjb(row.ijaFileRegisterForm)}
                >
                  下载
                </el-button> : ''
                }
                <el-button
                  size="mini"
                  type="text"
                  on-click={() => this.updataDjb(row.ijaId)}
                >
                  编辑
                </el-button>
              </span>
            );
          },
        },
        {
          field: "iuNameInstead",
          key: "iuNameInstead",
          title: "代面招聘",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaIdcard",
          key: "ijaIdcard",
          title: "身份证号",
          width: 140,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackFollow",
          key: "ijaFeedbackFollow",
          title: "面试评价(线下)",
          width: 500,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },
        // 复试
        {
          field: "ijaInterviewAgain",
          key: "ijaInterviewAgain",
          title: "复试官",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackInterviewAgain",
          key: "ijaFeedbackInterviewAgain",
          title: "复试反馈",
          width: 90,
          align: "center",
          edit: false,
        },
        // 发放offer
        {
          field: "ijaOffer",
          key: "ijaOffer",
          title: "是否发offer",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijaSalary",
          key: "ijaSalary",
          title: "薪资描述",
          width: 180,
          align: "center",
          edit: false,
        },
        {
          field: "ijaOfferRefuseReason",
          key: "ijaOfferRefuseReason",
          title: "婉拒offer原因",
          width: 200,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },
       
        // 入职手续
        {
          field: "ijaEntryStatus",
          key: "ijaEntryStatus",
          title: "是否办理入职手续",
          width: 120,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEntryRefuseReason",
          key: "ijaEntryRefuseReason",
          title: "不来报到原因",
          width: 200,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },
        // 一周留存是否转正
        {
          field: "ijaIntroduction",
          key: "ijaIntroduction",
          title: "个人简介",
          width: 300,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEntryWeek",
          key: "ijaEntryWeek",
          title: "一周留存",
          width: 80,
          align: "center",
          edit: false,
        },
        {
          field: "ijaRegularWorker",
          key: "ijaRegularWorker",
          title: "是否转正",
          width: 80,
          align: "center",
          edit: false,
        },
        // 离职
        {
          field: "ijaLeaveDate",
          key: "ijaLeaveDate",
          title: "离职时间",
          width: 90,
          align: "center",
          edit: false,
        },
        {
          field: "ijaLeaveReason",
          key: "ijaLeaveReason",
          title: "离职原因",
          width: 200,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },

        // { field: "createusername", key: "createusername", title: "创建人", width: 160, align: "center" },
        {
          field: "createtime",
          key: "c",
          title: "创建时间",
          width: 160,
          align: "center",
        },
        {
          field: "",
          key: "d",
          title: "操作",
          width: 250,
          fixed: "right",
          align: "center",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                {
                  row.hasBackStatus == 2 || row.hasBackStatus == 3 ? (<el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.gotoBackTone(row)}
                  >
                    背调
                  </el-button>) : ''
                }

                {row.ijaFeedbackFirst == "储备" ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.InviteClick(row)}
                  >
                    新增邀约
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaHasRecord == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.InterviewRecordClick(row)}
                  >
                    面试记录
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaAuthBase == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.handleEdit(row)}
                  >
                    编辑应聘者基础信息
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaAuthFace == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataFace(row)}
                  >
                    到面信息
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaAuthFaceAgain == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataFS(row)}
                  >
                    复试
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaAuthOffer == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataOffer(row)}
                  >
                    是否发放offer
                  </el-button>
                ) : (
                  ""
                )}

                {row.ijaAuthEntryStatus == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataRz(row)}
                  >
                    办理入职
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaAuthRegularWorker == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataJJ(row)}
                  >
                    个人简介
                  </el-button>
                ) : (
                  ""
                )}
                {row.ijaAuthEntryWeek == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataLC(row)}
                  >
                    留存
                  </el-button>
                ) : (
                  ""
                )}

                {row.ijaAuthRegularWorker == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataZZ(row)}
                  >
                    是否转正
                  </el-button>
                ) : (
                  ""
                )}

                {row.ijaAuthLeave == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataLeave(row)}
                  >
                    离职
                  </el-button>
                ) : (
                  ""
                )}
                {this.userid == 4 && row.ijaHide == 1 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataYc(row.ijaId)}
                  >
                    隐藏
                  </el-button>
                ) : (
                  ""
                )}
                {this.userid == 4 && row.ijaHide == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: green"
                    on-click={() => this.updataYc2(row.ijaId)}
                  >
                    取消隐藏
                  </el-button>
                ) : (
                  ""
                )}
                {this.postid == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.updataQX(row)}
                  >
                    权限
                  </el-button>
                ) : (
                  ""
                )}
                {this.postid != 2 && this.userid == row.iuId ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.updataApplyFor(row)}
                  >
                    申请权限
                  </el-button>
                ) : (
                  ""
                )}
                {row.qprStatus == 2 && row.qprId ? (
                  <el-button
                    size="mini"
                    type="text"
                    style={{ color: row.characterCode }}
                    on-click={() => this.DetailText(row.qprId)}
                  >
                    性格测试
                  </el-button>
                ) : (
                  ""
                )}
                {row.qprStatusTwo == 2 && row.qprIdTwo ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color:red"
                    on-click={() => this.DetailText(row.qprIdTwo)}
                  >
                    职业锚
                  </el-button>
                ) : (
                  ""
                )}
                {row.ioiId && row.ioiProgress != 1 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style={{ color: row.ioiProgress == 2 ? '#409EFF' : row.ioiProgress == 3 ? 'red' : row.ioiProgress == 4 ? '#E6A23C' : 'green' }}
                    on-click={() => this.gotoDetail(row)}
                  >
                    线上面试
                  </el-button>
                ) : (
                  ""
                )}
                {this.postid == 2 ? (
                  <el-button
                    size="mini"
                    type="text"
                    style="color: red"
                    on-click={() => this.handleDelete(row)}
                  >
                    删除
                  </el-button>
                ) : (
                  ""
                )}
              </span>
            );
          },
        },
      ], //表格的列
      columnsImport: [
        {
          field: "",
          key: "a",
          title: "序号",
          width: 50,
          align: "center",
          fixed: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          },
        },
        {
          field: "status",
          key: "status",
          title: "状态",
          width: 150,
          align: "center",
          fixed: "left",
          filter: {
            filterList: [
              { value: 0, label: "成功", selected: false },
              { value: 1, label: "失败", selected: false },
              { value: 3, label: "信息不完整", selected: false },
            ],
            isMultiple: true,
            // filter confirm hook
            filterConfirm: (filterList) => {
              //console.log(filterList);
              const labels = filterList
                .filter((x) => x.selected)
                .map((x) => x.label);
              this.searchByNameField(labels, "status");
            },
            // filter reset hook
            filterReset: (filterList) => {
              this.searchByNameField([]);
            },
            // max height
            maxHeight: 120,
          },
        },
        {
          field: "statusMsg",
          key: "statusMsg",
          title: "状态备注",
          fixed: "left",
          width: 150,
          align: "center",
        },
        {
          field: "iuName",
          key: "iuName",
          title: "招聘",
          width: 100,
          align: "center",
        },
        {
          field: "ijaPost",
          key: "ijaPost",
          title: "应聘岗位",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaName",
          key: "ijaName",
          title: "应聘者",
          width: 100,
          align: "center",
          edit: false,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <span>
                <el-button size="mini" type="text">
                  {row.ijaName}
                </el-button>
              </span>
            );
          },
        },
        {
          field: "ijaDateInvite",
          key: "ijaDateInvite",
          title: "邀约日期",
          width: 150,
          align: "center",
          edit: false,
        },
        {
          field: "ijcName",
          key: "ijcName",
          title: "招聘渠道",
          width: 150,
          align: "center",
          edit: false,
        },

        {
          field: "ijaPhone",
          key: "ijaPhone",
          title: "手机号码",
          width: 200,
          align: "center",
          edit: false,
        },
        {
          field: "ijaSex",
          key: "ijaSex",
          title: "性别",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEducationLevel",
          key: "ijaEducationLevel",
          title: "学历",
          width: 200,
          align: "center",
          edit: false,
        },

        {
          field: "ijaDateInterview",
          key: "ijaDateInterview",
          title: "面试日期",
          width: 200,
          align: "center",
          edit: false,
        },
        {
          field: "ijaTimeInterview",
          key: "ijaTimeInterview",
          title: "面试时间",
          width: 200,
          align: "center",
          edit: false,
        },
        // {
        //   field: "ijaFeedbackOnline",
        //   key: "ijaFeedbackOnline",
        //   title: "面试评价(线上)",
        //   width: 400,
        //   align: "center",
        //   edit: false,
        // },

        // 到面
        {
          field: "ijaFace",
          key: "ijaFace",
          title: "是否到面",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackFirst",
          key: "ijaFeedbackFirst",
          title: "初试反馈",
          width: 300,
          align: "center",
          edit: false,
        },
        {
          field: "iuNameInstead",
          key: "iuNameInstead",
          title: "代面招聘",
          width: 150,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackFollow",
          key: "ijaFeedbackFollow",
          title: "面试评价(线下)",
          width: 300,
          align: "center",
          edit: false,
          ellipsis: {
            showTitle: true,
            lineClamp: 2,
          },
        },
        // 复试
        {
          field: "ijaInterviewAgain",
          key: "ijaInterviewAgain",
          title: "复试官",
          width: 150,
          align: "center",
          edit: false,
        },
        {
          field: "ijaFeedbackInterviewAgain",
          key: "ijaFeedbackInterviewAgain",
          title: "复试反馈",
          width: 250,
          align: "center",
          edit: false,
        },
        // 发放offer
        {
          field: "ijaOffer",
          key: "ijaOffer",
          title: "是否发offer",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaSalary",
          key: "ijaSalary",
          title: "薪资描述",
          width: 200,
          align: "center",
          edit: false,
        },
        {
          field: "ijaOfferRefuseReason",
          key: "ijaOfferRefuseReason",
          title: "婉拒offer原因",
          width: 200,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEntryDateAgree",
          key: "ijaEntryDateAgree",
          title: "待入职时间",
          width: 200,
          align: "center",
          edit: false,
        },
        // 入职手续
        {
          field: "ijaEntryStatus",
          key: "ijaEntryStatus",
          title: "是否办理入职手续",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaEntryRefuseReason",
          key: "ijaEntryRefuseReason",
          title: "不来报到原因",
          width: 300,
          align: "center",
          edit: false,
        },
        // 一周留存是否转正
        {
          field: "ijaEntryWeek",
          key: "ijaEntryWeek",
          title: "一周留存",
          width: 100,
          align: "center",
          edit: false,
        },
        {
          field: "ijaRegularWorker",
          key: "ijaRegularWorker",
          title: "是否转正",
          width: 100,
          align: "center",
          edit: false,
        },
        // 离职
        {
          field: "ijaLeaveDate",
          key: "ijaLeaveDate",
          title: "离职时间",
          width: 200,
          align: "center",
          edit: false,
        },
        {
          field: "ijaLeaveReason",
          key: "ijaLeaveReason",
          title: "离职原因",
          width: 300,
          align: "center",
          edit: false,
        },

        {
          field: "createtime",
          key: "c",
          title: "创建时间",
          width: 160,
          align: "center",
        },
      ], //
      tableData: [],
      post: null,
      formDatas: {
        iuId: "",
        ijaPost: "",
        ijaBaseCity: "",
        ijcId: "",
        ijaName: "",
        ijaPhone: "",
        ijaSex: "",
        ijaEducationLevel: "",
        ijaFace: "",
        ijaFeedbackFirst: "",
        iuIdInstead: "",
        ijaInterviewAgain: "",
        ijaOffer: "",
        ijaEntryStatus: "",
        ijaEntryWeek: "",
        ijaRegularWorker: "",
        ijaDateInviteStart: "",
        ijaDateInviteEnd: "",
        ijaDateInterviewStart: "",
        ijaEducationLevel: "",
        ijaDateInterviewEnd: "",
        ijaEntryDateAgreeStart: "",
        ijaEntryDateAgreeEnd: "",
        currentPage: 1,
        pageSize: 10,
      },
      postid: "",

      // ===== 日历图模式 =====
      activeTab: 'list',      // 当前模式：list=应聘者列表（默认，原界面不变）；calendar=日历图
      calendarRecords: [],    // 日历数据：当前可视时间范围内有面试日期(ijaDateInterview)的记录
      currentRange: null,     // 子组件当前上报的可视时间范围（联动刷新时复用）
      calLoading: false,      // 日历数据加载状态
    };
  },
  activated() {
    this.watchFlag = true;
    this.$nextTick(() => {
      this.windheight = this.$store.state.windheight;
      this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    });
  },
  watch: {
    "$store.state.windheight"(val) {
      this.$nextTick(() => {
        if (this.watchFlag) {
          this.tableHight = val - 200 - val * 0.04;
        }
      });
    },
  },
  deactivated() {
    this.watchFlag = false;
  },
  created() {
    this.postid = localStorage.getItem("iuPost");
    this.userid = window.localStorage.getItem("iuId");
    this.windheight = this.$store.state.windheight;
    this.tableHight = this.windheight - 200 - this.windheight * 0.04;
    this.getList();
    getIvJobChannelList().then((res) => {
      this.getIvJobChannelList_data = res.data;
    });
    getIvJobApplicantPostList().then((res) => {
      this.getIvJobApplicantPostList_data = res.data;
    });
    getIvJobApplicantWareListMine().then((res) => {
      this.getIvJobApplicantWareList_data = res.data;
    });
    getIvUserList({ iuJoinInterview: 2 }).then((res) => {
      this.getIvUserList_data = res.data;
    });
    getIvUserList({ iuJoinInterview: 2, dmDelete: 1 }).then((res) => {
      this.getIvUserList_dataTwo = res.data;
    });
    this.getPost("industry");
  },
  mounted() { },
  methods: {
    Out2() {
      if (!this.selectedRowKeysCollection.length) {
        this.$message.warning("请至少选择一条记录");
        return;
      }
      const FormData = {
        ...this.formDatas,
        ijaIdList: JSON.stringify(this.selectedRowKeysCollection),
      }
      var s = qs.stringify(FormData);
      this.openLoading()
      var that = this
      axios({
        method: 'post',
        url: config.baseURL + '/iv-job-applicant/exportIvJobApplicantBiographicalNotes',
        data: s,
        // withCredentials: true,
        timeout: 1200000,
        responseType: 'arraybuffer',
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
          'userid': window.localStorage.getItem("iuId"),
        }
      }).then(function (res) {
        if (res.data) {
          that.loadings.close()
          let a = document.createElement('a');
          //ArrayBuffer 转为 Blob
          let blob = new Blob([res.data], {
            type: "application/zip"
          });
          let objectUrl = URL.createObjectURL(blob);
          a.setAttribute("href", objectUrl);
          a.setAttribute("download", '简历.zip');
          a.click();
          that.checkboxOption.selectedRowKeys = [];
          that.selectedRowKeysCollection = [];
          that.$message({
            message: "成功",
            type: "success"
          });

        }
      })
    },
    downloadJl(fileUrl) {
      if (!fileUrl) {
        this.$message.warning("简历文件不存在");
        return;
      }
      // 从URL中提取文件名
      const fileName = fileUrl.split("/").pop() || "简历.pdf";
      this.downloadFile(fileUrl, fileName);
    },
    downloadDjb(fileUrl) {
      if (!fileUrl) {
        this.$message.warning("登记表文件不存在");
        return;
      }
      // 从URL中提取文件名
      const fileName = fileUrl.split("/").pop() || "登记表.pdf";
      this.downloadFile(fileUrl, fileName);
    },
    downloadFile(url, name) {
      if (!url) {
        return;
      }
      // 在新窗口打开文件
      window.open(url, "_blank");
    },
    gotoBackTone(row) {
      if (row.hasBackStatus == 2) {
        this.$message({
          showClose: true,
          message: "正在背调中",
          type: "danger",
        });
        return
      }
      getIvJobApplicantBackgroundOne({ ijaId: row.ijaId }).then(res => {
        if (res.data) {
          this.backToneData = res.data;
          this.isBackTone = true;
        } else {
          this.$message({
            type: "danger",
            message: "暂无背调记录",
          });
        }
      })
    },
    closeBackTone() {
      this.isBackTone = false;
    },
    videoPreView(file) {
      this.videofile = file;
      this.isVideo = true;
    },
    videoPreViewClose() {
      this.isVideo = false;
    },
    detailClose() {
      this.isDetail = false;
      this.dateEnd = '';
      this.dateStart = '';
    },

    gotoDetail(row) {
      this.ioiId = row.ioiId
      getIvOnlineInterviewDetailsOne({ ioiId: row.ioiId }).then(res => {
        this.detailTable = res.data;
        this.SMcheckList = [];
        this.ZYMcheckList = [];
        for (var i = 0; i < res.data.ivqPaperRecordEye.ivqPaperTopicList.length; i++) {
          if (res.data.ivqPaperRecordEye.ivqPaperTopicList[i].qttId == 4) {
            this.SMcheckList.push(
              res.data.ivqPaperRecordEye.ivqPaperTopicList[i].qptAnswerIds || ""
            );
          } else {
            this.SMcheckList.push(
              (res.data.ivqPaperRecordEye.ivqPaperTopicList[i].qptAnswerIds || "")
                .split(",")
                .map(Number)
            );
          }
        }
        for (var i = 0; i < res.data.ivqPaperRecordTwo.ivqPaperTopicList.length; i++) {
          if (res.data.ivqPaperRecordTwo.ivqPaperTopicList[i].qttId == 4) {
            this.ZYMcheckList.push(
              res.data.ivqPaperRecordTwo.ivqPaperTopicList[i].qptAnswerIds || ""
            );
          } else {
            this.ZYMcheckList.push(
              (res.data.ivqPaperRecordTwo.ivqPaperTopicList[i].qptAnswerIds || "")
                .split(",")
                .map(Number)
            );
          }
        }
        this.isDetail = true;
      })
    },
    ...mapMutations(["getHomeNum"]),
    IuSureBtn() {
      const s = {
        ijaIds: this.selectedRowKeysCollection.toString(),
        iuId: this.iuIds,
      };
      updateIvJobApplicantOwner(s).then((res) => {
        this.IuhandleClose();
        this.getList();
      });
    },
    IuhandleClose() {
      this.iuIds = "";
      this.IsIuShow = false;
      this.selectedRowKeysCollection = [];
    },
    IuUpdata() {
      if (this.selectedRowKeysCollection.length == 0) {
        this.$message({
          showClose: true,
          message: "请选择",
          type: "danger",
        });
      } else {
        this.IsIuShow = true;
      }
    },
    IsIvRecordClose() {
      this.IsIvRecord = false;
    },
    InterviewRecordClick(row) {
      getIvJobApplicantRecordList({ ijaId: row.ijaId }).then((res) => {
        this.IvRecordData = res.data;
        this.IsIvRecord = true;
      });
    },
    ItSureBtn() {
      this.$confirm("是否确定, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          addIvJobApplicantRecord(this.formIt).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "申请成功!",
              });
              this.IthandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    IthandleClose() {
      this.isItShow = false;
      this.formIt = {};
      this.$refs["formIt"].resetFields();
    },
    InviteClick(row) {
      this.formIt.ijaId = row.ijaId;
      this.formIt.ijaPost = row.ijaPost;
      this.formIt.ijaPhone = row.ijaPhone;
      this.isItShow = true;
    },
    getIvNoticeList() {
      getIvNoticeList().then((res) => {
        //console.log(res.data);
        this.readNUmArr = res.data;
      });
      getIvNoticeUnReadNum().then((res) => {
        if (res.data == 0) {
          this.readNUm = "";
          return;
        }
        this.readNUm = res.data;
        const HomeNum = res.data;
        console.log(HomeNum);
        this.getHomeNum({ HomeNum });
      });
    },
    ijawIdChange(e) {
      console.log(e);
      this.getIvJobApplicantWareList_data.forEach((item, index) => {
        if (item.ijawId == e) {
          this.form.ijaName = item.ijawName;
          this.form.ijawId = item.ijawId;
          this.form.ijcId = item.ijcId;
          this.form.ijaPhone = item.ijawPhone;
          this.form.ijaSex = item.ijawSex;
          const arr = item.ijawEducationLevel.split(" ");
          if (arr.length <= 1) {
            if (arr[0].indexOf("全日制", 0) == -1) {
              this.education = "全日制";
              this.form.ijaEducationLevel = arr[0];
            } else {
              if (arr[0].indexOf("非全日制", 0) > -1) {
                this.education = arr[0].substring(
                  arr[0].indexOf("非全日制", 0),
                  arr[0].indexOf("非全日制", 0) + 4
                );
                this.form.ijaEducationLevel = arr[0].substring(
                  arr[0].indexOf("非全日制", 0) + 4,
                  arr[0].length
                );
              } else {
                this.education = arr[0].substring(
                  arr[0].indexOf("全日制", 0),
                  arr[0].indexOf("全日制", 0) + 3
                );
                this.form.ijaEducationLevel = arr[0].substring(
                  arr[0].indexOf("全日制", 0) + 3,
                  arr[0].length
                );
              }
            }
          } else {
            this.education = arr[0] ? arr[0] : "";
            this.form.ijaEducationLevel = arr[1] ? arr[1] : "";
          }
          console.log(this.form);
        }
      });
    },
    getAFList() {
      getIvJobApplicantAuthApplyList(this.AFformDatas).then((res) => {
        if (res.data) {
          this.MyAFData = res.data;
          this.AFtotalCount = res.total;
          getIvJobApplicantAuthApplyNums().then((res) => {
            this.AfNums = res.data;
          });
          this.getIvNoticeList();
        }
      });
    },
    checkedChange(e) {
      if (e) {
        for (let key in this.AFform) {
          if (key != "ijaId" && key != "ijaaaApplyDes") {
            this.AFform[key] = 2;
          }
        }
      } else {
        for (let key in this.AFform) {
          if (key != "ijaId" && key != "ijaaaApplyDes") {
            this.AFform[key] = "";
          }
        }
      }
    },
    afCloseClick(row) {
      this.$confirm("是否要取消申请, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantAuthApplyStatusCancel({
            ijaaaId: row.ijaaaId,
          }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "成功!",
              });
              this.getAFList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    afPostClick(row) {
      this.$confirm("是否确定要通过吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantAuthApplyStatus({
            ijaaaId: row.ijaaaId,
            ijaaaStatus: 2,
          }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "成功!",
              });
              this.getAFList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    UnafPostClick(row) {
      this.$confirm("是否确定要拒绝吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantAuthApplyStatus({
            ijaaaId: row.ijaaaId,
            ijaaaStatus: 3,
          }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "成功!",
              });
              this.getAFList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 性格测试详情
    DetailText(id) {
      getIvqPaperRecordDetails({ qprId: id }).then((res) => {
        this.topicArr = res.data;
        this.checkList = [];
        for (var i = 0; i < res.data.ivqPaperTopicList.length; i++) {
          if (res.data.ivqPaperTopicList[i].qttId == 4) {
            this.checkList.push(
              res.data.ivqPaperTopicList[i].qptAnswerIds || ""
            );
          } else {
            this.checkList.push(
              (res.data.ivqPaperTopicList[i].qptAnswerIds || "")
                .split(",")
                .map(Number)
            );
          }
        }
        this.isText = true;
      });
    },
    Out(command) {
      //console.log(command);
      if (this.selectedRowKeysCollection.length == 0 && !command) {
        this.$message({
          showClose: true,
          message: "请选择",
          type: "danger",
        });
      } else if (this.selectedRowKeysCollection.length > 0 && !command) {
        //console.log('开始导出', this.selectedRowKeysCollection)
        const bulkdata = {
          exportType: 2,
          ijaIds: this.selectedRowKeysCollection.toString(),
          ...this.formDatas,
        };
        var s = qs.stringify(bulkdata);
        this.openLoading();
        var that = this;
        axios({
          method: "post",
          url: config.baseURL + "/iv-job-applicant/exportIvJobApplicantList",
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: "arraybuffer",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            userid: window.localStorage.getItem("iuId"),
          },
        }).then(function (res) {
          if (res.data) {
            that.loadings.close();
            let a = document.createElement("a");
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            });
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "应聘者.xlsx");
            a.click();
            that.$message({
              message: "成功",
              type: "success",
            });
          }
        });
      } else {
        const bulkdata = {
          exportType: 1,
          ...this.formDatas,
        };
        var s = qs.stringify(bulkdata);
        this.openLoading();
        var that = this;
        axios({
          method: "post",
          url: config.baseURL + "/iv-job-applicant/exportIvJobApplicantList",
          data: s,
          withCredentials: true,
          timeout: 1200000,
          responseType: "arraybuffer",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            userid: window.localStorage.getItem("iuId"),
          },
        }).then(function (res) {
          if (res.data) {
            that.loadings.close();
            let a = document.createElement("a");
            //ArrayBuffer 转为 Blob
            let blob = new Blob([res.data], {
              type: "application/vnd.ms-excel",
            });
            let objectUrl = URL.createObjectURL(blob);
            a.setAttribute("href", objectUrl);
            a.setAttribute("download", "应聘者.xlsx");
            a.click();
            that.$message({
              message: "成功",
              type: "success",
            });
          }
        });
      }
    },

    closeSizer() {
      this.formDatas = {
        iuId: "",
        ijaPost: "",
        ijcId: "",
        ijaName: "",
        ijaPhone: "",
        ijaSex: "",
        ijaEducationLevel: "",
        ijaFace: "",
        ijaFeedbackFirst: "",
        iuIdInstead: "",
        ijaInterviewAgain: "",
        ijaOffer: "",
        ijaEntryStatus: "",
        ijaEntryWeek: "",
        ijaRegularWorker: "",
        ijaDateInviteStart: "",
        ijaDateInviteEnd: "",
        ijaDateInterviewStart: "",
        ijaEducationLevel: "",
        ijaDateInterviewEnd: "",
        ijaEntryDateAgreeStart: "",
        ijaEntryDateAgreeEnd: "",
        currentPage: 1,
        pageSize: 10,
      };
      this.IsSerch = false;
      this.partserch();
    },
    searchByNameField(labels, id) {
      this.bulkData = this.bulkDataCopy.filter(
        (x) => labels.length === 0 || labels.includes(x[id])
      );
    },
    gotoYuLan(url) {
      window.open(
        `https://filepreview.aojuai.com/onlinePreview?url=${encodeURIComponent(
          Base64.encode(url)
        )}`
      );
    },
    openLoading() {
      //loading请求等待
      this.loadings = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
    },
    bulkImportClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
          this.bulkData = [];
          this.bulkDataCopy = [];

          this.$nextTick(() => {
            this.getList();
          });
          this.$refs.bulk.clearFiles();
        })
        .catch((_) => { });
    },
    bulkImportClick() {
      if (this.sitId == "") {
        this.$message({
          showClose: true,
          message: "请导入资料",
          type: "danger",
        });
      } else {
        uploadImportIvJobApplicant({
          sitId: this.sitId,
        }).then((res) => {
          this.getList();
          this.bulkImport = false;
          this.bulkData = [];
          this.bulkDataCopy = [];
          this.sitId = "";
          this.$refs["bulk"].clearFiles();
          this.getList();
          this.$message({
            type: "success",
            message: "导入成功!",
          });
        });
      }
    },
    async updatabulk(file, fileList) {
      //console.log(file, fileList);
      let Data = new FormData();
      Data.append("file", file.raw);
      this.openLoading();
      uploadNcIvJobApplicant(Data).then((res) => {
        //console.log("上传成功")
        this.loadings.close();
        this.bulkData = res.data.data.resultList;
        this.bulkDataCopy = res.data.data.resultList;
        this.importData = res.data.data.importData;
        this.sitId = res.data.data.sysImportTem.sitId;
      });
    },
    onEnded() {
      this.audio = [];
      this.audioShow = false;
    },
    audioClick(row) {
      this.audio = [];
      const s = {
        title: row.ijaName,
        artist: row.ijaName,
        src: row.iaPath,
        pic: 'http://eos-shanghai-2.cmecloud.cn/aojv/interview/682c50e8278747d280437f3a438b990e.png', // prettier-ignore
        lrc: "",
      };
      this.audio.push(s);
      this.audioShow = true;
    },
    OtherImgChange(file) {
      if (file.length > 1) {
        this.audioFIle = file;
      } else {
        this.audioFIle = file;
        this.$set(this.formMS, "iaPath", file[0].fileurl);
        this.$message({
          type: "success",
          message: "上传成功!",
        });
      }
    },
    JLOtherImgChange(file) {
      if (file.length > 1) {
        this.audioFIle = file;
      } else {
        this.audioFIle = file;
        this.$set(this.formJL, "ijaBiographicalNotes", file[0].data);
        this.$message({
          type: "success",
          message: "上传成功!",
        });
      }
    },
    DjbOtherImgChange(file) {
      console.log(file);
      if (file.length > 1) {
        this.audioFIle = file;
      } else {
        this.audioFIle = file;
        this.$set(this.formDjb, "ijaFileRegisterForm", file[0].data);
        this.$message({
          type: "success",
          message: "上传成功!",
        });
      }
    },
    ApplyForClick() {
      getIvJobApplicantAuthApplyList(this.AFformDatas).then((res) => {
        if (res.data) {
          this.MyAFData = res.data;
          this.MyAFData = res.data;
          this.AFtotalCount = res.total;
          this.AFdataShow = true;
        }
      });
    },
    updataDetail(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.fileList = data;
      this.MyFileData = data.ivAudioList;
      this.myFileList = true;
    },
    updataAudio(row) {
      this.formMS = row;
      this.MSdialog = true;
    },
    updataJl(id) {
      this.formJL.ijaId = id;
      this.JLdialog = true;
    },
    updataDjb(id) {
      this.formDjb.ijaId = id;
      this.Djbdialog = true;
    },
    updataYc(id) {
      this.formYc.ijaId = id;
      this.formYc.ijaHide = 2;
      // this.Ycdialog = true;

      this.$confirm("是否确定要隐藏吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantHide(this.formYc).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.YchandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataYc2(id) {
      this.formYc.ijaId = id;
      this.formYc.ijaHide = 1;
      // this.Ycdialog = true;
      this.$confirm("是否确定要取消隐藏吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantHide(this.formYc).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.YchandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    fileGetList() {
      getIvAudioList({ ijaId: this.fileList.ijaId }).then((res) => {
        this.MyFileData = res.data;
      });
    },
    //申请权限
    updataApplyFor(row) {
      this.AFform.ijaId = JSON.parse(JSON.stringify(row)).ijaId;
      this.AFdialog = true;
    },
    //开放权限
    updataQX(row) {
      this.QXform = JSON.parse(JSON.stringify(row));
      this.QXdialog = true;
    },
    JLSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantBiographicalNotes(this.formJL).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.JLhandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    DjbSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantFileRegisterForm(this.formDjb).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.DjbhandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    MSSureBtn() {
      this.$confirm("是否确定要新增吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          addIvAudio(this.formMS).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.MShandleClose();
              this.getList();
              this.fileGetList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    YcSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantHide(this.formYc).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.YchandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    QXSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantAll(this.QXform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.QXhandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    AFSureBtn() {
      this.$confirm("是否确定申请吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          addIvJobApplicantAuthApply(this.AFform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "申请成功!",
              });
              this.AFhandleClose();
              this.getList();
              this.getIvNoticeList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    MShandleClose() {
      this.MSdialog = false;
      this.formMS = {};
      setTimeout(() => {
        this.$refs.OtherImgupload.fileAllRemove();
        this.OtherImgfileList = [];
      }, 10);
    },
    YchandleClose() {
      this.Ycdialog = false;
      this.formYc = {};
      // this.$refs['formYc'].resetFields();
    },
    QXhandleClose() {
      this.QXdialog = false;
      this.QXform = {};
      this.$refs["formQX"].resetFields();
    },
    AFhandleClose() {
      this.AFdialog = false;
      this.checked = false;
      this.AFform = {
        ijaId: "",
        ijaAuthBase: "",
        ijaAuthFace: "",
        ijaAuthFaceAgain: "",
        ijaAuthOffer: "",
        ijaAuthEntryStatus: "",
        ijaAuthEntryWeek: "",
        ijaAuthRegularWorker: "",
        ijaAuthLeave: "",
        ijaaaApplyDes: "",
      };
      this.$refs["formAF"].resetFields();
    },
    JLhandleClose() {
      this.JLdialog = false;
      this.formJL = {};
      setTimeout(() => {
        this.$refs.JLOtherImgupload.fileAllRemove();
        this.JLOtherImgfileList = [];
      }, 10);
    },
    DjbhandleClose() {
      this.Djbdialog = false;
      this.formDjb = {};
      setTimeout(() => {
        this.$refs.DjbOtherImgupload.fileAllRemove();
        this.DjbOtherImgfileList = [];
      }, 10);
    },
    // 详情
    getDetail(row) {
      getIvJobApplicantDetails({ ijaId: row }).then((res) => {
        // 兜底：后端对无录音的记录不返回 ivAudioList 字段，详情弹窗模板直接读
        // DetailStr.ivAudioList.length 会抛 TypeError，导致渲染中断、整页更新失效（弹窗假死）
        if (!res.data.ivAudioList) res.data.ivAudioList = [];
        this.DetailStr = res.data;
        this.isDetailDiaLog = true;
        //console.log(this.DetailStr);
      });
    },
    // 留存
    LCSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantEntryWeek(this.LCform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.LChandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    JJSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantIntroduction(this.JJform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.JJhandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataJJ(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.JJdialog = true;
      this.$nextTick(() => {
        this.JJform = data;
      });
    },
    updataLC(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.LCdialog = true;
      this.$nextTick(() => {
        this.LCform = data;
      });
    },
    // 复试
    FSSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantInterviewAgain(this.FSform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.FShandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataFS(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.FSdialog = true;
      this.$nextTick(() => {
        this.FSform = data;
      });
    },
    // ;离职
    LeaveSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantLeave(this.Leaveform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.LeavehandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataLeave(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.Leavedialog = true;
      this.$nextTick(() => {
        this.Leaveform = data;
      });
    },
    // 是否发offer
    OfferSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantOffer(this.Offerform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.OfferhandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataOffer(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.Offerdialog = true;
      this.$nextTick(() => {
        this.Offerform = data;
      });
    },
    // 是否转正
    ZZSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantRegularWorker(this.ZZform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.ZZhandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataZZ(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.ZZdialog = true;
      this.$nextTick(() => {
        this.ZZform = data;
      });
    },
    // 到面信息
    FaceSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantToFace(this.Faceform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.FacehandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataFace(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.Facedialog = true;
      this.$nextTick(() => {
        this.Faceform = data;
      });
    },
    RZSureBtn() {
      this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          updateIvJobApplicantEntryStatus(this.RZform).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "编辑成功!",
              });
              this.RZhandleClose();
              this.getList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    updataRz(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.RZdialog = true;
      this.$nextTick(() => {
        this.RZform = data;
      });
    },
    getPost(key) {
      const userpost = JSON.parse(sessionStorage.getItem("userPost")) || [];
      userpost.forEach((item, index) => {
        if (item.nsaMenuKey == key) {
          this.postForm[item.nsaFuncKey] = item.nsaFuncLabel;
        }
      });
    },
    handleDelete2(row) {
      this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteIvAudio({ iaId: row.iaId }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });

              this.fileGetList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleDelete(row) {
      this.$confirm("是否确定要删除吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteIvJobApplicant({ ijaIds: row.ijaId }).then((res) => {
            if (res.data) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });

              this.partserch();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    handleEdit(row) {
      const data = JSON.parse(JSON.stringify(row));
      this.dialog = true;
      this.edit = true;
      this.$nextTick(() => {
        this.form = data;
        const arr = data.ijaEducationLevel.split(" ");
        if (arr.length <= 1) {
          if (arr[0].indexOf("全日制", 0) == -1) {
            this.education = "全日制";
            this.form.ijaEducationLevel = arr[0];
          } else {
            if (arr[0].indexOf("非全日制", 0) > -1) {
              this.education = arr[0].substring(
                arr[0].indexOf("非全日制", 0),
                arr[0].indexOf("非全日制", 0) + 4
              );
              this.form.ijaEducationLevel = arr[0].substring(
                arr[0].indexOf("非全日制", 0) + 4,
                arr[0].length
              );
            } else {
              this.education = arr[0].substring(
                arr[0].indexOf("全日制", 0),
                arr[0].indexOf("全日制", 0) + 3
              );
              this.form.ijaEducationLevel = arr[0].substring(
                arr[0].indexOf("全日制", 0) + 3,
                arr[0].length
              );
            }
          }
        } else {
          this.education = arr[0] ? arr[0] : "";
          this.form.ijaEducationLevel = arr[1] ? arr[1] : "";
        }
      });
    },
    SureBtn() {
      if (!this.edit) {
        this.$confirm("是否确定要新增, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const newform = JSON.parse(JSON.stringify(this.form))
            newform.ijaEducationLevel = newform.ijaEducationLevel
              ? this.education + " " + newform.ijaEducationLevel
              : "";
            if (this.isTalent && this.form.ijawId == "") {
              return this.$message({
                type: "info",
                message: "请选择人才",
              });
            } else if (!this.isTalent) {
              this.form.ijawId == "";
              newform.ijawId == "";
            }
            addIvJobApplicant(newform).then((res) => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "新增成功!",
                });
                this.handleClose();
                this.getList();
              } else if (!res.data && res.item) {
                this.$confirm("应聘者已存在,请核对, 是否继续?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                  .then(() => {
                    this.form.ijaForceUp = 2;
                    newform.ijaForceUp = 2;
                    if (this.isTalent && this.form.ijawId == "") {
                      return this.$message({
                        type: "info",
                        message: "请选择人才",
                      });
                    } else if (!this.isTalent) {
                      this.form.ijawId == "";
                      newform.ijawId == "";
                    }
                    addIvJobApplicant(newform).then((res) => {
                      if (res.data) {
                        this.$message({
                          type: "success",
                          message: "新增成功!",
                        });
                        this.handleClose();
                        this.getList();
                      }
                    });
                  })
                  .catch(() => {
                    this.$message({
                      type: "info",
                      message: "已取消",
                    });
                  });
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } else {
        this.$confirm("是否确定要编辑吗, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            const newform = JSON.parse(JSON.stringify(this.form))
            newform.ijaEducationLevel = newform.ijaEducationLevel
              ? this.education + " " + newform.ijaEducationLevel
              : "";
            if (this.isTalent && this.form.ijawId == "") {
              return this.$message({
                type: "info",
                message: "请选择人才",
              });
            } else if (!this.isTalent) {
              this.form.ijawId == "";
              newform.ijawId == "";
            }
            updateIvJobApplicant(newform).then((res) => {
              if (res.data) {
                this.$message({
                  type: "success",
                  message: "编辑成功!",
                });
                this.handleClose();
                this.getList();
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    BoxOpen() {
      this.dialog = true;
    },
    // 关闭弹框
    LChandleClose() {
      this.LCdialog = false;
      this.$refs["formLC"].resetFields();
    },
    JJhandleClose() {
      this.JJdialog = false;
      this.$refs["formJJ"].resetFields();
    },
    // 关闭弹框
    FShandleClose() {
      this.FSdialog = false;
      this.$refs["formFS"].resetFields();
    },
    // 关闭弹框
    LeavehandleClose() {
      this.Leavedialog = false;
      this.$refs["formLeave"].resetFields();
    },
    // 关闭弹框
    OfferhandleClose() {
      this.Offerdialog = false;
      this.$refs["formOffer"].resetFields();
    },
    // 关闭弹框
    ZZhandleClose() {
      this.ZZdialog = false;
      this.$refs["formZZ"].resetFields();
    },
    // 关闭弹框
    FacehandleClose() {
      this.Facedialog = false;
      this.$refs["formFace"].resetFields();
    },
    // 关闭弹框
    RZhandleClose() {
      this.RZdialog = false;
      this.$refs["formRz"].resetFields();
    },
    // 关闭弹框
    handleClose() {
      this.dialog = false;
      this.edit = false;
      this.isTalent = false;
      this.ijawId = "";
      this.$refs["formRef"].resetFields();
    },
    // 修改单元格
    async beforeCellValChange(row, column, changeValue) {
      if (row[column.field] == changeValue) {
        return false;
      }

      this.$confirm("此操作将编辑该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var jsonObj = {};
          let formData = new FormData();
          formData.append(column.field, changeValue);
          formData.forEach((value, key) => (jsonObj[key] = value));
          jsonObj.ijaId = row.ijaId;
          //console.log(jsonObj);
          updateIvJobApplicant(jsonObj).then((res) => {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
          });
        })
        .catch(() => {
          this.lastValue = row[column.field];
          this.$nextTick(() => {
            this.tableData.forEach((item) => {
              for (let key in item) {
                if (key == column.field && item[key] == changeValue) {
                  item[key] = this.lastValue;
                }
                //console.log(key);
              }
            });
          });
          this.$message({
            type: "info",
            message: "已取消编辑",
          });
          return false;
        });
    },
    afterCellValChange(row, column, changeValue) {
      // //console.log(" afterCellValChange", row, column, changeValue);
    },
    // reset selectedRowKeys
    resetSelectedRowKeys(key) {
      this.checkboxOption.selectedRowKeys = [];

      const selectedRowKeysCollection = this.selectedRowKeysCollection;

      if (selectedRowKeysCollection.length) {
        this.tableData.forEach((item) => {
          if (selectedRowKeysCollection.indexOf(item[key]) > -1) {
            //console.log(item);
            this.checkboxOption.selectedRowKeys.push(item[key]);
          }
        });
      }
    },
    // select all change
    changeSelectAll(isSelected, selectedRowKeys, key) {
      this.checkboxOption.selectedRowKeys = selectedRowKeys;

      if (isSelected) {
        this.selectedRowKeysCollection =
          this.selectedRowKeysCollection.concat(selectedRowKeys) || [];
      } else {
        this.tableData.forEach((item, index) => {
          if (this.selectedRowKeysCollection.indexOf(item[key]) > -1) {
            this.selectedRowKeysCollection.splice(index, 1);
          }
        });
      }
    },
    changeSelectedRowKeys(row, isSelected, key) {
      const rowKey = row[key];

      if (isSelected) {
        this.checkboxOption.selectedRowKeys.push(rowKey);
        this.selectedRowKeysCollection.push(rowKey);
        //console.log(this.checkboxOption.selectedRowKeys, this.selectedRowKeysCollection);
      } else {
        const index = this.checkboxOption.selectedRowKeys.indexOf(rowKey);
        this.checkboxOption.selectedRowKeys.splice(index, 1);
        this.selectedRowKeysCollection.splice(index, 1);
      }
    },
    pageSizeChange(pageSize) {
      this.formDatas.pageSize = pageSize;
      this.partserch();
    },
    AFpageSizeChange(pageSize) {
      this.AFformDatas.pageSize = pageSize;
      this.getAFList();
    },
    pageNumberChange(pageIndex) {
      //console.log(pageIndex);
      this.formDatas.currentPage = pageIndex;
      getIvJobApplicantList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys(this.key);
        // this.$message({
        //   type: "success",
        //   message: "搜索成功!",
        // });
      });
    },
    AFpageNumberChange(pageIndex) {
      //console.log(pageIndex);
      this.AFformDatas.currentPage = pageIndex;
      getIvJobApplicantAuthApplyList(this.AFformDatas).then((res) => {
        this.MyAFData = res.data;
        this.AFtotalCount = res.total;
        this.resetSelectedRowKeys(this.key);
        // this.$message({
        //   type: "success",
        //   message: "搜索成功!",
        // });
      });
    },
    partserch() {
      this.formDatas.currentPage = 1;
      getIvJobApplicantList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        this.resetSelectedRowKeys(this.key);
        getIvJobApplicantAuthApplyNums().then((res) => {
          this.AfNums = res.data;
        });
        // this.$message({
        //   type: "success",
        //   message: "搜索成功!",
        // });
      });
      // 日历缓存联动刷新：日历模式下操作成功会走 partserch，按当前可视范围重新拉取
      if (this.currentRange) this.loadCalendarData(this.currentRange);
    },
    getList() {
      getIvJobApplicantList(this.formDatas).then((res) => {
        this.tableData = res.data;
        this.totalCount = res.total;
        getIvJobApplicantAuthApplyNums().then((res) => {
          this.AfNums = res.data;
        });
      });
      // 日历联动刷新：编辑/删除等操作成功后走 getList，按当前可视范围重新拉取
      if (this.currentRange) this.loadCalendarData(this.currentRange);
    },
    // ==================== 日历图模式 ====================
    // 子组件上报可视范围（月视图整月含补位、周视图当周）→ 按面试日期范围拉取
    // 用后端已有的 ijaDateInterviewStart/End 范围筛选，避免全量拉取超时；
    // 不带列表筛选条件——日历是「当天有多少面试」的全局视角
    loadCalendarData(range) {
      if (!range || !range.start || !range.end) return;
      this.currentRange = range;
      this.calLoading = true;
      getIvJobApplicantList({
        currentPage: 1,
        pageSize: 2000,
        ijaDateInterviewStart: range.start,
        ijaDateInterviewEnd: range.end,
      }).then((res) => {
        // 只保留有面试日期的记录；排序交给子组件（按面试日期+时间升序）
        this.calendarRecords = (res.data || []).filter((r) => r.ijaDateInterview);
        this.calLoading = false;
      }).catch(() => {
        this.calLoading = false;
      });
    },
    // 打开关联弹框
    openAssociateDialog(row) {
      this.currentAssociateRow = row;
      this.selectedInterviewRecord = null;
      // 获取所有面试登记表记录
      const params = {
        hasSignRelation: 1,
        currentPage: 1,
        pageSize: 500,
      };
      getIvInterviewApplicantList(params).then((res) => {
        this.interviewRecordList = res.data || [];
        this.associateDialogVisible = true;
      });
    },
    // 关联弹框关闭
    associateDialogClose() {
      this.currentAssociateRow = null;
      this.interviewRecordList = [];
      this.selectedInterviewRecord = null;
    },
    // 确认关联
    confirmAssociate() {
      if (!this.selectedInterviewRecord) {
        this.$message({
          showClose: true,
          message: "请选择面试记录",
          type: 'warning'
        });
        return;
      }
      const params = {
        iiaId: this.selectedInterviewRecord,
        ijaId: this.currentAssociateRow.ijaId,
      };
      updateIvInterviewApplicantSignUser(params).then((res) => {
        if (res.status) {
          this.$message({
            type: "success",
            message: "关联成功!",
          });
          this.associateDialogVisible = false;
          this.getList();
        }
      });
    },
  },
};
</script>

<style>
.el-badge__content.is-fixed {
  right: 27px !important;
}

.item {
  margin-right: 20px;
}

.textclass .el-radio--medium.is-bordered {
  width: 100% !important;
  height: auto !important;
  padding: 5px 15px !important;
}

.textclass .el-radio {
  white-space: inherit !important;
  line-height: 2 !important;
}

.table-header-cell-class {
  background: var(--bg-color) !important;
  color: var(--font-color) !important;
  border-right: 0px !important;
}

.easetable::-webkit-scrollbar {
  display: none;
}

.ve-table-container {
  height: auto !important;
}

/* ==================== 日历图模式（ac- 前缀，与列表模式隔离） ==================== */
/* 模式切换 tab：紧凑化，避免挤压下方列表区域 */
.ac-tabs-wrap {
  width: 97%;
  margin: 6px auto 0;
  padding: 0 10px;
}
.ac-tabs-wrap .el-tabs__header {
  margin-bottom: 4px;
}
.ac-tabs-wrap .el-tabs__item {
  height: 36px;
  line-height: 36px;
}
</style>
